export const HYPHENATION = [
    ["blessed", "bless-ed"],
    ["is", "is"],
    ["the", "the"],
    ["man", "man"],
    ["that", "that"],
    ["hath", "hath"],
    ["not", "not"],
    ["walked", "walk-ed"],
    ["in", "in"],
    ["counsel", "coun-sel"],
    ["of", "of"],
    ["ungodly", "un-god-ly"],
    ["nor", "nor"],
    ["stood", "stood"],
    ["way", "way"],
    ["sinners", "sin-ners"],
    ["and", "and"],
    ["sat", "sat"],
    ["seat", "seat"],
    ["scornful", "scornf-ul"],
    ["but", "but"],
    ["his", "his"],
    ["delight", "de-light"],
    ["law", "law"],
    ["lord", "lord"],
    ["will", "will"],
    ["he", "he"],
    ["exercise", "ex-er-cise"],
    ["himself", "him-self"],
    ["day", "day"],
    ["night", "night"],
    ["shall", "shall"],
    ["be", "be"],
    ["like", "like"],
    ["a", "a"],
    ["tree", "tree"],
    ["planted", "plan-ted"],
    ["by", "by"],
    ["water-side", "wa-ter_side"],
    ["bring", "bring"],
    ["forth", "forth"],
    ["fruit", "fruit"],
    ["due", "due"],
    ["season", "sea-son"],
    ["leaf", "leaf"],
    ["also", "al-so"],
    ["wither", "wi-ther"],
    ["look", "look"],
    ["whatsoever", "what-so-ev-er"],
    ["doeth", "do-eth"],
    ["it", "it"],
    ["prosper", "pros-per"],
    ["as", "as"],
    ["for", "for"],
    ["so", "so"],
    ["with", "with"],
    ["them", "them"],
    ["they", "they"],
    ["are", "are"],
    ["chaff", "chaff"],
    ["which", "which"],
    ["wind", "wind"],
    ["scattereth", "scat-ter-eth"],
    ["away", "a-way"],
    ["from", "from"],
    ["face", "face"],
    ["earth", "earth"],
    ["therefore", "there-fore"],
    ["able", "able"],
    ["to", "to"],
    ["stand", "stand"],
    ["judgment", "judg-ment"],
    ["neither", "nei-ther"],
    ["congregation", "con-gre-ga-tion"],
    ["righteous", "right-eous"],
    ["knoweth", "know-eth"],
    ["perish", "per-ish"],
    ["why", "why"],
    ["do", "do"],
    ["heathen", "heath-en"],
    ["furiously", "fu-ri-ous-ly"],
    ["rage", "rage"],
    ["together", "to-ge-ther"],
    ["people", "peo-ple"],
    ["imagine", "im-a-gine"],
    ["vain", "vain"],
    ["thing", "thing"],
    ["kings", "kings"],
    ["up", "up"],
    ["rulers", "rul-ers"],
    ["take", "take"],
    ["against", "a-gainst"],
    ["anointed", "a-noin-ted"],
    ["let", "let"],
    ["us", "us"],
    ["break", "break"],
    ["their", "their"],
    ["bonds", "bonds"],
    ["asunder", "a-sun-der"],
    ["cast", "cast"],
    ["cords", "cords"],
    ["dwelleth", "dwell-eth"],
    ["heaven", "hea-ven"],
    ["laugh", "laugh"],
    ["scorn", "scorn"],
    ["have", "have"],
    ["derision", "de-ri-sion"],
    ["then", "then"],
    ["speak", "speak"],
    ["unto", "un-to"],
    ["wrath", "wrath"],
    ["vex", "vex"],
    ["sore", "sore"],
    ["displeasure", "dis-plea-sure"],
    ["yet", "yet"],
    ["i", "i"],
    ["set", "set"],
    ["my", "my"],
    ["king", "king"],
    ["upon", "up-on"],
    ["holy", "ho-ly"],
    ["hill", "hill"],
    ["sion", "si-on"],
    ["rehearse", "re-hearse"],
    ["decree", "de-cree"],
    ["said", "said"],
    ["me", "me"],
    ["thou", "thou"],
    ["art", "art"],
    ["son", "son"],
    ["this", "this"],
    ["begotten", "be-got-ten"],
    ["thee", "thee"],
    ["desire", "de-sire"],
    ["give", "give"],
    ["nations", "na-tions"],
    ["thine", "thine"],
    ["inheritance", "in-he-ri-tance"],
    ["utmost", "ut-most"],
    ["parts", "parts"],
    ["thy", "thy"],
    ["possession", "poss-ess-ion"],
    ["shalt", "shalt"],
    ["bruise", "bruise"],
    ["rod", "rod"],
    ["iron", "i-ron"],
    ["pieces", "pie-ces"],
    ["potters", "pot-ters"],
    ["vessel", "vess-el"],
    ["wise", "wise"],
    ["now", "now"],
    ["o", "o"],
    ["ye", "ye"],
    ["instructed", "in-struct-ed"],
    ["judges", "judg-es"],
    ["serve", "serve"],
    ["fear", "fear"],
    ["rejoice", "re-joice"],
    ["him", "him"],
    ["reverence", "re-ver-ence"],
    ["kiss", "kiss"],
    ["lest", "lest"],
    ["angry", "angry"],
    ["right", "right"],
    ["if", "if"],
    ["kindled", "kin-dled"],
    ["yea", "yea"],
    ["little", "lit-tle"],
    ["all", "all"],
    ["put", "put"],
    ["trust", "trust"],
    ["how", "how"],
    ["increased", "in-creased"],
    ["trouble", "trou-ble"],
    ["many", "ma-ny"],
    ["rise", "rise"],
    ["one", "one"],
    ["there", "there"],
    ["say", "say"],
    ["soul", "soul"],
    ["no", "no"],
    ["help", "help"],
    ["god", "god"],
    ["defender", "de-fen-der"],
    ["worship", "wor-ship"],
    ["lifter", "lif-ter"],
    ["head", "head"],
    ["did", "did"],
    ["call", "call"],
    ["voice", "voice"],
    ["heard", "heard"],
    ["out", "out"],
    ["laid", "laid"],
    ["down", "down"],
    ["slept", "slept"],
    ["rose", "rose"],
    ["again", "a-gain"],
    ["sustained", "sus-tained"],
    ["afraid", "a-fraid"],
    ["ten", "ten"],
    ["thousands", "thou-sands"],
    ["themselves", "them-selves"],
    ["round", "round"],
    ["about", "a-bout"],
    ["smitest", "smit-est"],
    ["mine", "mine"],
    ["enemies", "e-ne-mies"],
    ["cheek-bone", "cheek-bone"],
    ["hast", "hast"],
    ["broken", "bro-ken"],
    ["teeth", "teeth"],
    ["salvation", "sal-va-tion"],
    ["belongeth", "be-long-eth"],
    ["blessing", "bless-ing"],
    ["hear", "hear"],
    ["when", "when"],
    ["righteousness", "right-eous-ness"],
    ["at", "at"],
    ["liberty", "li-ber-ty"],
    ["was", "was"],
    ["mercy", "mer-cy"],
    ["hearken", "hear-ken"],
    ["prayer", "prayer"],
    ["sons", "sons"],
    ["men", "men"],
    ["long", "long"],
    ["blaspheme", "blas-pheme"],
    ["honour", "ho-nour"],
    ["such", "such"],
    ["pleasure", "plea-sure"],
    ["vanity", "va-ni-ty"],
    ["seek", "seek"],
    ["after", "af-ter"],
    ["falsehood", "false-hood"],
    ["know", "know"],
    ["chosen", "cho-sen"],
    ["godly", "god-ly"],
    ["awe", "awe"],
    ["sin", "sin"],
    ["commune", "comm-une"],
    ["your", "your"],
    ["own", "own"],
    ["heart", "heart"],
    ["chamber", "cham-ber"],
    ["still", "still"],
    ["offer", "off-er"],
    ["sacrifice", "sac-ri-fice"],
    ["who", "who"],
    ["show", "show"],
    ["any", "any"],
    ["good", "good"],
    ["lift", "lift"],
    ["up", "up"],
    ["light", "light"],
    ["countenance", "coun-te-nance"],
    ["gladness", "glad-ness"],
    ["more", "more"],
    ["than", "than"],
    ["corn", "corn"],
    ["wine", "wine"],
    ["oil", "oil"],
    ["increase", "in-crease"],
    ["lay", "lay"],
    ["peace", "peace"],
    ["rest", "rest"],
    ["only", "only"],
    ["makest", "mak-est"],
    ["dwell", "dwell"],
    ["safety", "safe-ty"],
    ["ponder", "pon-der"],
    ["words", "words"],
    ["consider", "con-si-der"],
    ["meditation", "me-di-ta-tion"],
    ["calling", "call-ing"],
    ["make", "make"],
    ["betimes", "be-times"],
    ["early", "ear-ly"],
    ["morning", "mor-ning"],
    ["direct", "di-rect"],
    ["wickedness", "wick-ed-ness"],
    ["evil", "e-vil"],
    ["foolish", "fool-ish"],
    ["sight", "sight"],
    ["hatest", "hat-est"],
    ["work", "work"],
    ["iniquity", "in-i-qui-ty"],
    ["destroy", "des-troy"],
    ["lies", "lies"],
    ["abhor", "ab-hor"],
    ["both", "both"],
    ["blood-thirsty", "blood_thirs-ty"],
    ["deceitful", "de-ceit-ful"],
    ["multitude", "mul-ti-tude"],
    ["come", "come"],
    ["into", "in-to"],
    ["house", "house"],
    ["toward", "to-ward"],
    ["temple", "tem-ple"],
    ["lead", "lead"],
    ["because", "be-cause"],
    ["plain", "plain"],
    ["before", "be-fore"],
    ["faithfulness", "faith-ful-ness"],
    ["mouth", "mouth"],
    ["inward", "in-ward"],
    ["very", "ve-ry"],
    ["throat", "throat"],
    ["an", "an"],
    ["open", "open"],
    ["sepulchre", "se-pul-chre"],
    ["flatter", "flat-ter"],
    ["tongue", "tongue"],
    ["through", "through"],
    ["imaginations", "i-ma-gi-na-tions"],
    ["ungodliness", "un-god-li-ness"],
    ["rebelled", "re-belled"],
    ["ever", "ev-er"],
    ["giving", "gi-ving"],
    ["thanks", "thanks"],
    ["defendest", "de-fend-est"],
    ["love", "love"],
    ["name", "name"],
    ["joyful", "joy-ful"],
    ["wilt", "wilt"],
    ["favourable", "fa-vour-a-ble"],
    ["kindness", "kind-ness"],
    ["defend", "de-fend"],
    ["shield", "shield"],
    ["rebuke", "re-buke"],
    ["indignation", "in-dig-na-tion"],
    ["chasten", "chas-ten"],
    ["am", "am"],
    ["weak", "weak"],
    ["heal", "heal"],
    ["bones", "bones"],
    ["vexed", "vexed"],
    ["troubled", "trou-bled"],
    ["punish", "pu-nish"],
    ["turn", "turn"],
    ["deliver", "de-li-ver"],
    ["save", "save"],
    ["mercys", "mer-cys"],
    ["sake", "sake"],
    ["death", "death"],
    ["remembereth", "re-mem-ber-eth"],
    ["pit", "pit"],
    ["weary", "wea-ry"],
    ["groaning", "groan-ing"],
    ["every", "eve-ry"],
    ["wash", "wash"],
    ["bed", "bed"],
    ["water", "water"],
    ["couch", "couch"],
    ["tears", "tears"],
    ["beauty", "beau-ty"],
    ["gone", "gone"],
    ["worn", "worn"],
    ["weeping", "weep-ing"],
    ["petition", "pe-ti-tion"],
    ["receive", "re-ceive"],
    ["confounded", "con-foun-ded"],
    ["turned", "turned"],
    ["back", "back"],
    ["shame", "shame"],
    ["suddenly", "sud-den-ly"],
    ["persecute", "per-se-cute"],
    ["devour", "de-vour"],
    ["lion", "li-on"],
    ["tear", "tear"],
    ["while", "while"],
    ["none", "none"],
    ["done", "done"],
    ["or", "or"],
    ["hands", "hands"],
    ["rewarded", "re-war-ded"],
    ["dealt", "dealt"],
    ["friendly", "friend-ly"],
    ["yea", "yea"],
    ["delivered", "de-li-vered"],
    ["without", "with-out"],
    ["cause", "cause"],
    ["enemy", "e-ne-my"],
    ["tread", "tread"],
    ["life", "life"],
    ["dust", "dust"],
    ["thyself", "thy-self"],
    ["arise", "a-rise"],
    ["commanded", "com-man-ded"],
    ["peoples", "peo-ples"],
    ["sakes", "sakes"],
    ["judge", "judge"],
    ["sentence", "sen-tence"],
    ["according", "ac-cor-ding"],
    ["innocency", "in-no-cen-cy"],
    ["end", "end"],
    ["guide", "guide"],
    ["just", "just"],
    ["trieth", "tri-eth"],
    ["hearts", "hearts"],
    ["reins", "reins"],
    ["cometh", "com-eth"],
    ["preserveth", "pre-ser-veth"],
    ["true", "true"],
    ["strong", "strong"],
    ["patient", "pa-tient"],
    ["provoked", "pro-voked"],
    ["whet", "whet"],
    ["sword", "sword"],
    ["bent", "bent"],
    ["bow", "bow"],
    ["made", "made"],
    ["ready", "rea-dy"],
    ["prepared", "pre-pared"],
    ["instruments", "inst-ru-ments"],
    ["ordaineth", "or-dain-eth"],
    ["arrows", "arr-ows"],
    ["persecutors", "per-se-cu-tors"],
    ["behold", "be-hold"],
    ["travaileth", "tra-vail-eth"],
    ["conceived", "con-ceived"],
    ["mischief", "mis-chief"],
    ["brought", "brought"],
    ["graven", "gra-ven"],
    ["digged", "digged"],
    ["fallen", "fall-en"],
    ["destruction", "des-truc-tion"],
    ["other", "oth-er"],
    ["travail", "tra-vail"],
    ["fall", "fall"],
    ["on", "on"],
    ["pate", "pate"],
    ["praise", "praise"],
    ["most", "most"],
    ["high", "high"],
    ["our", "our"],
    ["governor", "go-ver-nor"],
    ["excellent", "ex-cell-ent"],
    ["world", "world"],
    ["glory", "glo-ry"],
    ["above", "a-bove"],
    ["heavens", "hea-vens"],
    ["babes", "babes"],
    ["sucklings", "suck-lings"],
    ["ordained", "or-dained"],
    ["strength", "strength"],
    ["mightest", "might-est"],
    ["avenger", "a-ven-ger"],
    ["even", "e-ven"],
    ["fingers", "fing-ers"],
    ["moon", "moon"],
    ["stars", "stars"],
    ["what", "what"],
    ["mindful", "mind-ful"],
    ["visitest", "vis-it-est"],
    ["madest", "mad-est"],
    ["lower", "low-er"],
    ["angels", "an-gels"],
    ["crown", "crown"],
    ["dominion", "do-min-ion"],
    ["works", "works"],
    ["things", "things"],
    ["subjection", "sub-jec-tion"],
    ["under", "un-der"],
    ["feet", "feet"],
    ["sheep", "sheep"],
    ["oxen", "oxen"],
    ["beasts", "beasts"],
    ["field", "field"],
    ["fowls", "fowls"],
    ["air", "air"],
    ["fishes", "fish-es"],
    ["sea", "sea"],
    ["walketh", "walk-eth"],
    ["paths", "paths"],
    ["seas", "seas"],
    ["whole", "whole"],
    ["marvellous", "mar-vell-ous"],
    ["glad", "glad"],
    ["songs", "songs"],
    ["highest", "high-est"],
    ["driven", "driv-en"],
    ["presence", "pres-ence"],
    ["maintained", "main-tained"],
    ["throne", "throne"],
    ["judgest", "judg-est"],
    ["rebuked", "re-buked"],
    ["destroyed", "des-troy-ed"],
    ["destructions", "des-truc-tions"],
    ["perpetual", "per-pe-tu-al"],
    ["cities", "ci-ties"],
    ["whose", "whose"],
    ["memorial", "me-mor-i-al"],
    ["perished", "per-ished"],
    ["endure", "en-dure"],
    ["minister", "mi-ni-ster"],
    ["defence", "de-fence"],
    ["oppressed", "op-pressed"],
    ["refuge", "re-fuge"],
    ["time", "time"],
    ["never", "nev-er"],
    ["failed", "failed"],
    ["doings", "do-ings"],
    ["maketh", "mak-eth"],
    ["inquisition", "in-qui-si-tion"],
    ["blood", "blood"],
    ["forgetteth", "for-gett-eth"],
    ["complaint", "com-plaint"],
    ["poor", "poor"],
    ["suffer", "suf-fer"],
    ["hate", "hate"],
    ["liftest", "lift-est"],
    ["gates", "gates"],
    ["may", "may"],
    ["praises", "prais-es"],
    ["within", "with-in"],
    ["daughter", "daugh-ter"],
    ["sunk", "sunk"],
    ["same", "same"],
    ["net", "net"],
    ["hid", "hid"],
    ["privily", "pri-vi-ly"],
    ["foot", "foot"],
    ["taken", "tak-en"],
    ["known", "known"],
    ["execute", "ex-e-cute"],
    ["trapped", "trapped"],
    ["wicked", "wick-ed"],
    ["forget", "for-get"],
    ["alway", "al-way"],
    ["forgotten", "for-got-ten"],
    ["abiding", "a-bi-ding"],
    ["meek", "meek"],
    ["upper", "up-per"],
    ["hand", "hand"],
    ["judged", "judged"],
    ["standest", "stand-est"],
    ["far", "far"],
    ["off", "off"],
    ["hidest", "hid-est"],
    ["needful", "need-ful"],
    ["lust", "lust"],
    ["doth", "doth"],
    ["crafty", "craf-ty"],
    ["wiliness", "wi-li-ness"],
    ["imagined", "im-a-gined"],
    ["boast", "boast"],
    ["hearts", "hearts"],
    ["speaketh", "speak-eth"],
    ["covetous", "co-ve-tous"],
    ["whom", "whom"],
    ["abhorreth", "ab-horr-eth"],
    ["proud", "proud"],
    ["careth", "ca-reth"],
    ["thoughts", "thoughts"],
    ["ways", "ways"],
    ["grievous", "grie-vous"],
    ["judgments", "judg-ments"],
    ["defieth", "de-fieth"],
    ["tush", "tush"],
    ["harm", "harm"],
    ["happen", "hap-pen"],
    ["full", "full"],
    ["cursing", "cur-sing"],
    ["deceit", "de-ceit"],
    ["fraud", "fraud"],
    ["sitteth", "sitt-eth"],
    ["lurking", "lur-king"],
    ["thievish", "thiev-ish"],
    ["corners", "cor-ners"],
    ["streets", "streets"],
    ["dens", "dens"],
    ["murder", "mur-der"],
    ["innocent", "in-no-cent"],
    ["eyes", "eyes"],
    ["lieth", "li-eth"],
    ["waiting", "wait-ing"],
    ["secretly", "se-cret-ly"],
    ////////
    ["lurketh", "lurk-eth"],
    ["den", "den"],
    ["ravish", "ra-vish"],
    ["getteth", "gett-eth"],
    ["falleth", "fall-eth"],
    ["humbleth", "humb-leth"],
    ["captains", "cap-tains"],
    ["hideth", "hid-eth"],
    ["see", "see"],
    ["wherefore", "where-fore"],
    ["should", "should"],
    ["carest", "car-est"],
    ["surely", "sure-ly"],
    ["seen", "seen"],
    ["beholdest", "be-hold-est"],
    ["wrong", "wrong"],
    ["mayest", "may-est"],
    ["matter", "mat-ter"],
    ["committeth", "com-mitt-eth"],
    ["helper", "hel-per"],
    ["friendless", "friend-less"],
    ["power", "power"],
    ["malicious", "ma-li-cious"],
    ["search", "search"],
    ["until", "un-til"],
    ["find", "find"],
    ["land", "land"],
    ["preparest", "pre-par-est"],
    ["ear", "ear"],
    ["hearkeneth", "hear-ken-eth"],
    ["fatherless", "fa-ther-less"],
    ["exalted", "ex-al-ted"],
    ["she", "she"],
    ["flee", "flee"],
    ["bird", "bird"],
    ["lo", "lo"],
    ["bend", "bend"],
    ["quiver", "qui-ver"],
    ["shoot", "shoot"],
    ["foundations", "found-a-tions"],
    ["can", "can"],
    ["lords", "lords"],
    ["eyelids", "eye-lids"],
    ["try", "try"],
    ["children", "child-ren"],
    ["approveth", "app-ro-veth"],
    ["delighteth", "de-light-eth"],
    ["rain", "rain"],
    ["snares", "snares"],
    ["fire", "fire"],
    ["brimstone", "brim-stone"],
    ["storm", "storm"],
    ["tempest", "tem-pest"],
    ["portion", "por-tion"],
    ["drink", "drink"],
    ["loveth", "lov-eth"],
    ["left", "left"],
    ["faithful", "faith-ful"],
    ["minished", "min-ished"],
    ["among", "a-mong"],
    ["talk", "talk"],
    ["neighbour", "neigh-bour"],
    ["lips", "lips"],
    ["dissemble", "diss-em-ble"],
    ["double", "double"],
    ["root", "root"],
    ["we", "we"],
    ["prevail", "pre-vail"],
    ["ought", "ought"],
    ["over", "o-ver"],
    ["comfortless", "com-fort-less"],
    ["troubles", "trou-bles"],
    ["needy", "nee-dy"],
    ["deep", "deep"],
    ["sighing", "sigh-ing"],
    ["saith", "saith"],
    ["swelleth", "swell-eth"],
    ["pure", "pure"],
    ["silver", "sil-ver"],
    ["tried", "tried"],
    ["purified", "pu-ri-fied"],
    ["seven", "se-ven"],
    ["times", "times"],
    ["keep", "keep"],
    ["preserve", "pre-serve"],
    ["generation", "ge-ne-ra-tion"],
    ["walk", "walk"],
    ["side", "side"],
    ["hide", "hide"],
    ["triumph", "tri-umph"],
    ["lighten", "light-en"],
    ["sleep", "sleep"],
    ["prevailed", "pre-vailed"],
    ["sing", "sing"],
    ["lovingly", "lov-ing-ly"],
    ["fool", "fool"],
    ["corrupt", "cor-rupt"],
    ["become", "be-come"],
    ["abominable", "a-bom-in-a-ble"],
    ["looked", "looked"],
    ["were", "were"],
    ["would", "would"],
    ["understand", "un-der-stand"],
    ["altogether", "al-to-ge-ther"],
    ["knowledge", "know-ledge"],
    ["workers", "wor-kers"],
    ["eating", "ea-ting"],
    ["bread", "bread"],
    ["great", "great"],
    ["where", "where"],
    ["you", "you"],
    ["mock", "mock"],
    ["putteth", "putt-eth"],
    ["israel", "is-r-ael"],
    ["turneth", "tur-neth"],
    ["captivity", "cap-ti-vi-ty"],
    ["jacob", "ja-cob"],
    ["psalm", "psalm"],
    ////////
    ["tabernacle", "tab-er-na-cle"],
    ["leadeth", "lead-eth"],
    ["uncorrupt", "un-corr-upt"],
    ["truth", "truth"],
    ["used", "used"],
    ["slandered", "slan-dered"],
    ["setteth", "set-teth"],
    ["lowly", "low-ly"],
    ["much", "much"],
    ["sweareth", "swear-eth"],
    ["disappointeth", "dis-app-oin-teth"],
    ["though", "though"],
    ["hindrance", "hind-rance"],
    ["given", "gi-ven"],
    ["money", "mo-ney"],
    ["usury", "us-u-ry"],
    ["reward", "re-ward"],
    ["whoso", "who-so"],
    ["these", "these"],
    ["saints", "saints"],
    ["excel", "ex-cel"],
    ["virtue", "vir-tue"],
    ["run", "run"],
    ["another", "a-no-ther"],
    ["drink-offerings", "drink_off-er-ings"],
    ["mention", "men-tion"],
    ["names", "names"],
    ["cup", "cup"],
    ["maintain", "main-tain"],
    ["lot", "lot"],
    ["fair", "fair"],
    ["ground", "ground"],
    ["goodly", "good-ly"],
    ["heritage", "he-ri-tage"],
    ["thank", "thank"],
    ["warning", "war-ning"],
    ["rejoiceth", "re-joic-eth"],
    ["flesh", "flesh"],
    ["hope", "hope"],
    ["leave", "leave"],
    ["hell", "hell"],
    ["corruption", "cor-rup-tion"],
    ["path", "path"],
    ["fulness", "ful-ness"],
    ["joy", "joy"],
    ["evermore", "ev-er-more"],
    ["goeth", "go-eth"],
    ///////
    ["feigned", "feigned"],
    ["equal", "e-qual"],
    ["proved", "proved"],
    ["visited", "vis-it-ed"],
    ["utterly", "utt-er-ly"],
    ["purposed", "pur-posed"],
    ["offend", "off-end"],
    ["word", "word"],
    ["kept", "kept"],
    ["destroyer", "des-troy-er"],
    ["hold", "hold"],
    ["goings", "go-ings"],
    ["footsteps", "foot-steps"],
    ["slip", "slip"],
    ["called", "called"],
    ["incline", "in-cline"],
    ["loving-kindness", "lov-ing_kind-ness"],
    ["saviour", "sav-iour"],
    ["resist", "res-ist"],
    ["apple", "ap-ple"],
    ["eye", "eye"],
    ["shadow", "sha-dow"],
    ["wings", "wings"],
    ["compass", "com-pass"],
    ["inclosed", "in-closed"],
    ["fat", "fat"],
    ["lie", "lie"],
    ["watching", "watch-ing"],
    ["greedy", "gree-dy"],
    ["prey", "prey"],
    ["lions", "li-ons"],
    ["whelp", "whelp"],
    ["secret", "sec-ret"],
    ["places", "pla-ces"],
    ["disappoint", "dis-ap-point"],
    ["bellies", "bell-ies"],
    ["fillest", "fill-est"],
    ["treasure", "trea-sure"],
    ["substance", "sub-stance"],
    ["awake", "a-wake"],
    ["likeness", "like-ness"],
    ["satisfied", "sa-tis-fied"],
    ["stony", "stony"],
    ["rock", "rock"],
    ["might", "might"],
    ["buckler", "buck-ler"],
    ["horn", "horn"],
    ["worthy", "wor-thy"],
    ["praised", "praised"],
    ["safe", "safe"],
    ["sorrows", "sor-rows"],
    ["compassed", "com-passed"],
    ["overflowings", "o-ver-flow-ings"],
    ["pains", "pains"],
    ["came", "came"],
    ["overtook", "o-ver-took"],
    ["complained", "com-plained"],
    ["entered", "en-tered"],
    ["ears", "ears"],
    ["trembled", "trem-bled"],
    ["quaked", "quaked"],
    ["hills", "hills"],
    ["shook", "shook"],
    ["removed", "re-moved"],
    ["wroth", "wroth"],
    ["went", "went"],
    ["smoke", "smoke"],
    ["consuming", "con-su-ming"],
    ["coals", "coals"],
    ["bowed", "bowed"],
    ["dark", "dark"],
    ["rode", "rode"],
    ["cherubim", "che-ru-bim"],
    ["fly", "fly"],
    ["flying", "fly-ing"],
    ["darkness", "dark-ness"],
    ["place", "place"],
    ["pavilion", "pa-vil-ion"],
    ["thick", "thick"],
    ["clouds", "clouds"],
    ["cover", "cover"],
    ["brightness", "bright-ness"],
    ["hailstones", "hail-stones"],
    ["thundered", "thun-dered"],
    ["gave", "gave"],
    ["thunder", "thun-der"],
    ["sent", "sent"],
    ["scattered", "scat-tered"],
    ["lightnings", "light-nings"],
    ["springs", "springs"],
    ["waters", "wa-ters"],
    ["discovered", "dis-co-vered"],
    ["chiding", "chid-ing"],
    ["blasting", "blast-ing"],
    ["breath", "breath"],
    ["fetch", "fetch"],
    ["took", "took"],
    ["strongest", "strong-est"],
    ["too", "too"],
    ["mighty", "migh-ty"],
    ["upholder", "up-hold-er"],
    ["had", "had"],
    ["favour", "favour"],
    ["dealing", "deal-ing"],
    ["cleanness", "clean-ness"],
    ["recompense", "re-com-pense"],
    ["forsaken", "for-saken"],
    ["laws", "laws"],
    ["commandments", "com-mand-ments"],
    ["eschewed", "es-chewed"],
    ["eyesight", "eye-sight"],
    ["perfect", "per-fect"],
    ["clean", "clean"],
    ["froward", "fro-ward"],
    ["adversity", "ad-ver-si-ty"],
    ["looks", "looks"],
    ["candle", "can-dle"],
    ["discomfit", "dis-com-fit"],
    ["host", "host"],
    ["leap", "leap"],
    ["wall", "wall"],
    ["undefiled", "un-de-filed"],
    ["except", "ex-cept"],
    ["girdeth", "gird-eth"],
    ["war", "war"],
    ["harts", "harts"],
    ["teacheth", "teach-eth"],
    ["fight", "fight"],
    ["arms", "arms"],
    ["steel", "steel"],
    ["loving", "lov-ing"],
    ["correction", "cor-rec-tion"],
    ["room", "room"],
    ["enough", "en-ough"],
    ["go", "go"],
    ["slide", "slide"],
    ["follow", "fol-low"],
    ["overtake", "o-ver-take"],
    ["till", "till"],
    ["smite", "smite"],
    ["girded", "gir-ded"],
    ["battle", "bat-tle"],
    ["throw", "throw"],
    ["backs", "backs"],
    ["cry", "cry"],
    ["beat", "beat"],
    ["small", "small"],
    ["clay", "clay"],
    ["strivings", "striv-ings"],
    ["soon", "soon"],
    ["obey", "o-bey"],
    ["strangers", "stran-gers"],
    ["feign", "feign"],
    ["obedience", "o-be-di-ence"],
    ["fail", "fail"],
    ["trembling", "trem-bling"],
    ["strongholds", "strong-holds"],
    ["liveth", "liv-eth"],
    ["seeth", "seeth"],
    ["avenged", "av-enged"],
    ["subdueth", "sub-du-eth"],
    ["delivereth", "de-li-ver-eth"],
    ["cruel", "cru-el"],
    ["adversaries", "ad-ver-sa-ries"],
    ["rid", "rid"],
    ["gentiles", "gen-tiles"],
    ["prosperity", "pros-pe-ri-ty"],
    ["giveth", "gi-veth"],
    ["showeth", "show-eth"],
    ["david", "da-vid"],
    ["seed", "seed"],
    ["declare", "de-clare"],
    ["firmament", "fir-ma-ment"],
    ["handy-work", "han-dy_work"],
    ["telleth", "tell-eth"],
    ["certifieth", "cer-ti-fi-eth"],
    ////////////////
    ["speech", "speech"],
    ["language", "lang-uage"],
    ["voices", "voi-ces"],
    ["sound", "sound"],
    ["lands", "lands"],
    ["ends", "ends"],
    ["sun", "sun"],
    ["bridegroom", "bride-groom"],
    ["giant", "gi-ant"],
    ["course", "course"],
    ["uttermost", "ut-ter-most"],
    ["part", "part"],
    ["runneth", "runn-eth"],
    ["nothing", "noth-ing"],
    ["heat", "heat"],
    ["thereof", "there-of"],
    ["converting", "con-ver-ting"],
    ["testimony", "tes-ti-mo-ny"],
    ["sure", "sure"],
    ["wisdom", "wis-dom"],
    ["simple", "sim-ple"],
    ["statutes", "stat-utes"],
    ["commandment", "com-mand-ment"],
    ["endureth", "en-dur-eth"],
    ["desired", "de-sired"],
    ["gold", "gold"],
    ["fine", "fine"],
    ["sweeter", "swee-ter"],
    ["honey", "hon-ey"],
    ["honeycomb", "hon-ey-comb"],
    ["moreover", "more-ov-er"],
    ["servant", "ser-vant"],
    ["taught", "taught"],
    ["keeping", "keep-ing"],
    ["tell", "tell"],
    ["oft", "oft"],
    ["offendeth", "off-end-eth"],
    ["cleanse", "cleanse"],
    ["faults", "faults"],
    ["presumptuous", "pre-sump-tu-ous"],
    ["sins", "sins"],
    ["get", "get"],
    ["offence", "off-ence"],
    ["acceptable", "ac-cep-ta-ble"],
    ["redeemer", "re-dee-mer"],
    ["send", "send"],
    ["sanctuary", "sanc-tu-a-ry"],
    ["strengthen", "strength-en"],
    ["remember", "re-mem-ber"],
    ["offerings", "of-fer-ings"],
    ["accept", "ac-cept"],
    ["burnt-sacrifice", "burnt_sac-ri-fice"],
    ["grant", "grant"],
    ["fulfil", "ful-fil"],
    ["mind", "mind"],
    ["perform", "per-form"],
    ["petitions", "pe-ti-tions"],
    ["helpeth", "help-eth"],
    ["wholesome", "whole-some"],
    ["some", "some"],
    ["chariots", "cha-ri-ots"],
    ["horses", "hor-ses"],
    ["risen", "ri-sen"],
    ["upright", "up-right"],
    ["exceeding", "ex-ceed-ing"],
    ["denied", "de-nied"],
    ["request", "re-quest"],
    ["meet", "meet"],
    ["blessings", "bless-ings"],
    ["goodness", "good-ness"],
    ["asked", "asked"],
    ["gavest", "gav-est"],
    ["everlasting", "ev-er-last-ing"],
    ["felicity", "fe-li-ci-ty"],
    ["miscarry", "mis-car-ry"],
    ["feel", "feel"],
    ["fiery", "fie-ry"],
    ["oven", "ov-en"],
    ["consume", "con-sume"],
    ["intended", "in-ten-ded"],
    ["device", "de-vice"],
    ["flight", "flight"],
    ["strings", "strings"],
    ["health", "health"],
    ["day-time", "day_time"],
    ["hearest", "hear-est"],
    ["continuest", "con-ti-nu-est"],
    ["fathers", "fathers"],
    ["hoped", "hoped"],
    ["trusted", "trust-ed"],
    ["didst", "didst"],
    ["holpen", "hol-pen"],
    ["worm", "worm"],
    ["outcast", "out-cast"],
    ["shake", "shake"],
    ["heads", "heads"],
    ["saying", "say-ing"],
    ["mothers", "mo-thers"],
    ["womb", "womb"],
    ["wast", "wast"],
    ["hanged", "hanged"],
    ["breasts", "breasts"],
    ["been", "been"],
    ["since", "since"],
    ["born", "born"],
    ["hard", "hard"],
    ["bulls", "bulls"],
    ["bashan", "ba-shan"],
    ["close", "close"],
    ["gape", "gape"],
    ["mouths", "mouths"],
    ["ramping", "ramp-ing"],
    ["roaring", "roar-ing"],
    ["poured", "poured"],
    ["joint", "joint"],
    ["midst", "midst"],
    ["body", "bo-dy"],
    ["melting", "mel-ting"],
    ["wax", "wax"],
    ["dried", "dried"],
    ["potsherd", "pot-sherd"],
    ["cleaveth", "cleav-eth"],
    ["gums", "gums"],
    ["bringest", "bring-est"],
    ["dogs", "dogs"],
    ["council", "coun-cil"],
    ["layeth", "lay-eth"],
    ["siege", "siege"],
    ["pierced", "pierced"],
    ["staring", "star-ing"],
    ["looking", "look-ing"],
    ["garments", "gar-ments"],
    ["lots", "lots"],
    ["vesture", "ves-ture"],
    ["succour", "suc-cour"],
    ["haste", "haste"],
    ["darling", "dar-ling"],
    ["dog", "dog"],
    ["horns", "horns"],
    ["unicorns", "u-ni-corns"],
    ["brethren", "breth-ren"],
    ["magnify", "mag-ni-fy"],
    ["despised", "desp-ised"],
    ["abhorred", "ab-horred"],
    ["low", "low"],
    ["estate", "es-tate"],
    ["great-congregation", "great_con-gre-ga-tion"],
    ["vows", "vows"],
    ["eat", "eat"],
    ["live", "live"],
    ["kindreds", "kind-reds"],
    ["kingdom", "king-dom"],
    ["eaten", "eat-en"],
    ["worshipped", "wor-shipped"],
    ["kneel", "kneel"],
    ["quickened", "quick-ened"],
    ["counted", "coun-ted"],
    ["shepherd", "shep-herd"],
    ["lack", "lack"],
    ["feed", "feed"],
    ["green", "green"],
    ["pasture", "pas-ture"],
    ["beside", "be-side"],
    ["comfort", "com-fort"],
    ["convert", "con-vert"],
    ["names", "names"],
    ["valley", "val-ley"],
    ["staff", "staff"],
    ["prepare", "pre-pare"],
    ["table", "ta-ble"],
    ["days", "days"],
    ["therein", "there-in"],
    ["founded", "foun-ded"],
    ["stablished", "stab-lished"],
    ["floods", "floods"],
    ["ascend", "asc-end"],
    ["sworn", "sworn"],
    ["deceive", "de-ceive"],
    ["doors", "doors"],
    ["hosts", "hosts"],
    ["ashamed", "a-shamed"],
    ["transgress", "trans-gress"],
    ["confusion", "con-fu-sion"],
    ["teach", "teach"],
    ["learn", "learn"],
    ["remembrance", "re-mem-brance"],
    ["tender", "ten-der"],
    ["mercies", "mer-cies"],
    ["loving-kindnesses", "lov-ing_kind-ness-es"],
    ["old", "old"],
    ["offences", "off-en-ces"],
    ["youth", "youth"],
    ["think", "think"],
    ["gracious", "gra-cious"],
    ["gentle", "gen-tle"],
    ["covenant", "co-ve-nant"],
    ["testimonies", "tes-ti-mon-ies"],
    ["merciful", "mer-ci-ful"],
    ["feareth", "fear-eth"],
    ["choose", "choose"],
    ["ease", "ease"],
    ["inherit", "in-he-rit"],
    ["pluck", "pluck"],
    ["desolate", "de-so-late"],
    ["misery", "mi-se-ry"],
    ["enlarged", "en-larged"],
    ["troubles", "trou-bles"],
    ["forgive", "for-give"],
    ["bear", "bear"],
    ["tyrannous", "ty-ran-nous"],
    ["perfectness", "per-fect-ness"],
    ["wait", "wait"],
    ["innocently", "in-no-cent-ly"],
    ["examine", "ex-am-ine"],
    ["prove", "prove"],
    ["dwelt", "dwelt"],
    ["persons", "per-sons"],
    ["fellowship", "fel-low-ship"],
    ["hated", "hat-ed"],
    ["sit", "sit"],
    ["altar", "al-tar"],
    ["thanksgiving", "thanks-giv-ing"],
    ["wondrous", "won-drous"],
    ["loved", "loved"],
    ["habitation", "ha-bi-ta-tion"],
    ["shut", "shut"],
    ["gifts", "gifts"],
    ["standeth", "stand-eth"],
    ["congregations", "con-gre-ga-tions"],
    ["foes", "foes"],
    ["stumbled", "stum-bled"],
    ["fell", "fell"],
    ["require", "re-quire"],
    ["visit", "vis-it"],
    ["dwelling", "dwell-ing"],
    ["stone", "stone"],
    ["oblation", "ob-la-tion"],
    ["talked", "talked"],
    ["forsake", "for-sake"],
    ["father", "fa-ther"],
    ["mother", "mo-ther"],
    ["taketh", "tak-eth"],
    ["false", "false"],
    ["witnesses", "wit-ness-es"],
    ["fainted", "faint-ed"],
    ["believe", "be-lieve"],
    ["verily", "ve-ri-ly"],
    ["living", "li-ving"],
    ["tarry", "tar-ry"],
    ["leisure", "lei-sure"],
    ["humble", "hum-ble"],
    ["towards", "to-wards"],
    ["mercyseat", "mer-cy-seat"],
    ["doers", "do-ers"],
    ["neighbours", "neigh-bours"],
    ["deeds", "deeds"],
    ["inventions", "in-ven-tions"],
    ["pay", "pay"],
    ["deserved", "des-erved"],
    ["regard", "re-gard"],
    ["operation", "op-er-a-tion"],
    ["build", "build"],
    ["helped", "helped"],
    ["danceth", "danc-eth"],
    ["song", "song"],
    ["ascribe", "a-scribe"],
    ["glorious", "glo-rious"],
    ["ruleth", "rul-eth"],
    ["breaketh", "break-eth"],
    ["cedar-trees", "ce-dar_trees"],
    ["cedars", "cedars"],
    ["lebanon", "le-ba-non"],
    ["skip", "skip"],
    ["calf", "calf"],
    ["sirion", "sir-ion"],
    ["young", "young"],
    ["unicorn", "u-ni-corn"],
    ["divideth", "di-vi-deth"],
    ["flames", "flames"],
    ["shaketh", "shak-eth"],
    ["wilderness", "wil-der-ness"],
    ["kadesh", "ka-desh"],
    ["hinds", "hinds"],
    ["strippeth", "strip-peth"],
    ["bare", "bare"],
    ["forests", "for-ests"],
    ["water-flood", "wa-ter_flood"],
    ["remaineth", "re-main-eth"],
    ["cried", "cried"],
    ["healed", "healed"],
    ["holiness", "ho-li-ness"],
    ["twinkling", "twink-ling"],
    ["heaviness", "hea-vi-ness"],
    ["gat", "gat"],
    ["humbly", "humb-ly"],
    ["profit", "pro-fit"],
    ["sackcloth", "sack-cloth"],
    ["ceasing", "ceas-ing"],
    ["castle", "cas-tle"],
    ["draw", "draw"],
    ["commend", "com-mend"],
    ["spirit", "spi-rit"],
    ["redeemed", "re-deemed"],
    ["lying", "ly-ing"],
    ["vanities", "va-ni-ties"],
    ["considered", "con-sid-ered"],
    ["adversities", "ad-ver-si-ties"],
    ["large", "large"],
    ["consumed", "con-sumed"],
    ["waxen", "wax-en"],
    ["years", "years"],
    ["mourning", "mourn-ing"],
    ["faileth", "fail-eth"],
    ["became", "be-came"],
    ["reproach", "rep-roach"],
    ["especially", "es-pe-cial-ly"],
    ["acquaintance", "ac-quain-tance"],
    ["conveyed", "con-veyed"],
    ["dead", "dead"],
    ["blasphemy", "blas-phe-my"],
    ["conspire", "con-spire"],
    ["silence", "si-lence"],
    ["grave", "grave"],
    ["cruelly", "cruel-ly"],
    ["disdainfully", "dis-dain-ful-ly"],
    ["despitefully", "des-pite-ful-ly"],
    ["plentiful", "plen-ti-ful"],
    ["covert", "co-vert"],
    ["plottings", "plot-tings"],
    ["strife", "strife"],
    ["tongues", "tongues"],
    ["showed", "showed"],
    ["city", "ci-ty"],
    ["nevertheless", "ne-ver-the-less"],
    ["heardest", "heard-est"],
    ["plenteously", "plent-eous-ly"],
    ["rewardeth", "re-ward-eth"],
    ["doer", "do-er"],
    ["establish", "est-ab-lish"],
    ["unrighteousness", "un-right-eous-ness"],
    ["forgiven", "for-gi-ven"],
    ["covered", "co-vered"],
    ["imputeth", "im-put-eth"],
    ["guile", "guile"],
    ["whilst", "whilst"],
    ["held", "held"],
    ["daily", "dai-ly"],
    ["complaining", "com-plain-ing"],
    ["heavy", "hea-vy"],
    ["moisture", "mois-ture"],
    ["drought", "drought"],
    ["summer", "sum-mer"],
    ["acknowledged", "ack-now-ledged"],
    ["confess", "con-fess"],
    ["forgavest", "for-gav-est"],
    ["found", "found"],
    ["water-floods", "wa-ter_floods"],
    ["nigh", "nigh"],
    ["deliverance", "de-li-ver-ance"],
    ["inform", "in-form"],
    ["wherein", "where-in"],
    ["horse", "horse"],
    ["mule", "mule"],
    ["understanding", "un-der-stan-ding"],
    ["must", "must"],
    ["bit", "bit"],
    ["bridle", "bri-dle"],
    ["else", "else"],
    ["plagues", "plagues"],
    ["remain", "re-main"],
    ["embraceth", "em-brac-eth"],
    ["becometh", "be-com-eth"],
    ["well", "well"],
    ["thankful", "thank-ful"],
    ["harp", "harp"],
    ["lute", "lute"],
    ["instrument", "in-stru-ment"],
    ["new", "new"],
    ["lustily", "lus-ti-ly"],
    ["courage", "cou-rage"],
    ["gathereth", "ga-ther-eth"],
    ["heap", "heap"],
    ["treasure-house", "trea-sure_house"],
    ["spake", "spake"],
    ["fast", "fast"],
    ["bringeth", "bring-eth"],
    ["nought", "nought"],
    ["devices", "de-vices"],
    ["effect", "eff-ect"],
    ["casteth", "cast-eth"],
    ["counsels", "coun-sels"],
    ["princes", "prin-ces"],
    ["jehovah", "je-ho-vah"],
    ["folk", "folk"],
    ["looketh", "look-eth"],
    ["beholdeth", "be-hold-eth"],
    ["considereth", "con-si-der-eth"],
    ["fashioneth", "fa-shion-eth"],
    ["understandeth", "un-der-stand-eth"],
    ["saved", "saved"],
    ["dearth", "dearth"],
    ["patiently", "pa-tient-ly"],
    ["tarried", "tar-ried"],
    ["her", "her"],
    ["sought", "sought"],
    ["lightened", "light-ened"],
    ["faces", "fa-ces"],
    ["crieth", "cri-eth"],
    ["heareth", "hear-eth"],
    ["saveth", "sav-eth"],
    ["angel", "an-gel"],
    ["tarrieth", "tar-ri-eth"],
    ["taste", "taste"],
    ["trusteth", "trust-eth"],
    ["lions", "li-ons"],
    ["hunger", "hun-ger"],
    ["want", "want"],
    ["manner", "man-ner"],
    ["lusteth", "lust-eth"],
    ["fain", "fain"],
    ["eschew", "es-chew"],
    ["ensue", "en-sue"],
    ["prayers", "prayers"],
    ["contrite", "con-trite"],
    ["keepeth", "keep-eth"],
    ["misfortune", "mis-for-tune"],
    ["slay", "slay"],
    ["souls", "souls"],
    ["servants", "ser-vants"],
    ["destitute", "des-ti-tute"],
    ["plead", "plead"],
    ["strive", "strive"],
    ["spear", "spear"],
    ["stop", "stop"],
    ["pursue", "pur-sue"],
    ["scattering", "scat-ter-ing"],
    ["slippery", "slip-pe-ry"],
    ["sudden", "sud-den"],
    ["unawares", "un-a-wares"],
    ["catch", "catch"],
    ["deliverest", "de-li-ver-est"],
    ["spoileth", "spoil-eth"],
    ["charge", "charge"],
    ["knew", "knew"],
    ["discomfort", "dis-com-fort"],
    ["sick", "sick"],
    ["humbled", "hum-bled"],
    ["fasting", "fast-ing"],
    ["bosom", "bo-som"],
    ["behaved", "be-haved"],
    ["myself", "my-self"],
    ["friend", "friend"],
    ["brother", "bro-ther"],
    ["heavily", "hea-vi-ly"],
    ["mourneth", "mourn-eth"],
    ["rejoiced", "re-joiced"],
    ["gathered", "ga-thered"],
    ["abjects", "ab-jects"],
    ["making", "ma-king"],
    ["ceased", "ceased"],
    ["flatterers", "flat-ter-ers"],
    ["busy", "bu-sy"],
    ["mockers", "mock-ers"],
    ["gnashed", "gnashed"],
    ["calamities", "ca-la-mi-ties"],
    ["wink", "wink"],
    ["communing", "com-mun-ing"],
    ["quiet", "qui-et"],
    ["gaped", "gaped"],
    ["fie", "fie"],
    ["saw", "saw"],
    ["quarrel", "quar-rel"],
    ["avenge", "a-venge"],
    ["devoured", "de-voured"],
    ["clothed", "clothed"],
    ["dishonour", "dis-hon-our"],
    ["talking", "talk-ing"],
    ["flattereth", "flat-ter-eth"],
    ["unrighteous", "un-right-eous"],
    ["behave", "be-have"],
    ["wisely", "wise-ly"],
    ["imagineth", "i-ma-gin-eth"],
    ["reacheth", "reach-eth"],
    ["mountains", "moun-tains"],
    ["beast", "beast"],
    ["plenteousness", "plen-teous-ness"],
    ["pleasures", "plea-sures"],
    ["river", "ri-ver"],
    ["continue", "con-tin-ue"],
    ["pride", "pride"],
    ["fret", "fret"],
    ["envious", "en-vi-ous"],
    ["cut", "cut"],
    ["grass", "grass"],
    ["withered", "with-ered"],
    ["herb", "herb"],
    ["doing", "do-ing"],
    ["fed", "fed"],
    ["commit", "com-mit"],
    ["pass", "pass"],
    ["clear", "clear"],
    ["noon-day", "noon_day"],
    ["abide", "ab-ide"],
    ["grieve", "grieve"],
    ["moved", "moved"],
    ["rooted", "root-ed"],
    ["those", "those"],
    ["meek-spirited", "meek_spi-ri-ted"],
    ["possess", "pos-sess"],
    ["refreshed", "re-freshed"],
    ["seeketh", "seek-eth"],
    ["gnasheth", "gnash-eth"],
    ["to-scorn", "to_scorn"],
    ["coming", "com-ing"],
    ["drawn", "drawn"],
    ["better", "bet-ter"],
    ["riches", "rich-es"],
    ["upholdeth", "up-hold-eth"],
    ["perilous", "pe-ri-lous"],
    ["lambs", "lambs"],
    ["borroweth", "bor-row-eth"],
    ["payeth", "pay-eth"],
    ["liberal", "lib-er-al"],
    ["cursed", "cursed"],
    ["ordereth", "or-der-eth"],
    ["mans", "mans"],
    ["going", "go-ing"],
    ["begging", "beg-ging"],
    ["lendeth", "len-deth"],
    ["forsaketh", "for-sak-eth"],
    ["preserved", "pre-ser-ved"],
    ["punished", "pun-ished"],
    ["exercised", "ex-er-cised"],
    ["watcheth", "watch-eth"],
    ["occasion", "oc-ca-sion"],
    ["condemn", "con-demn"],
    ["promote", "pro-mote"],
    ["flourishing", "flour-ish-ing"],
    ["bay-tree", "bay_tree"],
    ["could", "could"],
    ["heed", "heed"],
    ["last", "last"],
    ["transgressors", "trans-gres-sors"],
    ["anger", "an-ger"],
    ["stick", "stick"],
    ["presseth", "press-eth"],
    ["reason", "rea-son"],
    ["wickednesses", "wick-ed-ness-es"],
    ["burden", "bur-den"],
    ["wounds", "wounds"],
    ["stink", "stink"],
    ["foolishness", "fool-ish-ness"],
    ["loins", "loins"],
    ["filled", "filled"],
    ["disease", "dis-ease"],
    ["feeble", "fee-ble"],
    ["smitten", "smit-ten"],
    ["roared", "roar-ed"],
    ["disquietness", "dis-qui-et-ness"],
    ["knowest", "know-est"],
    ["panteth", "pan-teth"],
    ["lovers", "lov-ers"],
    ["kinsmen", "kins-men"],
    ["afar", "af-ar"],
    ["deaf", "deaf"],
    ["dumb", "dumb"],
    ["reproofs", "re-proofs"],
    ["answer", "an-swer"],
    ["required", "re-quired"],
    ["slipt", "slipt"],
    ["greatly", "great-ly"],
    ["truly", "tru-ly"],
    ["plague", "plague"],
    ["sorry", "sor-ry"],
    ["wrongfully", "wrong-ful-ly"],
    ["number", "num-ber"],
    ["pain", "pain"],
    ["grief", "grief"],
    ["hot", "hot"],
    ["thus", "thus"],
    ["musing", "mus-ing"],
    ["certified", "cer-ti-fied"],
    ["span", "span"],
    ["age", "age"],
    ["respect", "res-pect"],
    ["disquieteth", "dis-qui-et-eth"],
    ["heapeth", "heap-eth"],
    ["cannot", "can-not"],
    ["gather", "gath-er"],
    ["opened", "o-pened"],
    ["means", "means"],
    ["rebukes", "re-bukes"],
    ["dost", "dost"],
    ["moth", "moth"],
    ["fretting", "frett-ing"],
    ["garment", "gar-ment"],
    ["stranger", "stran-ger"],
    ["sojourner", "so-jour-ner"],
    ["spare", "spare"],
    ["recover", "re-co-ver"],
    ["hence", "hence"],
    ["waited", "wait-ed"],
    ["inclined", "in-clined"],
    ["horrible", "hor-ri-ble"],
    ["mire", "mire"],
    ["ordered", "or-dered"],
    ["us-ward", "us_ward"],
    ["express", "ex-press"],
    ["offering", "off-er-ing"],
    ["wouldest", "would-est"],
    ["burnt-offering", "burnt_off-er-ing"],
    ["volume", "vol-ume"],
    ["book", "book"],
    ["written", "writ-ten"],
    ["content", "con-tent"],
    ["declared", "de-clared"],
    ["refrain", "re-frain"],
    ["withdraw", "with-draw"],
    ["innumerable", "in-nu-me-ra-ble"],
    ["hairs", "hairs"],
    ["backward", "back-ward"],
    ["wish", "wish"],
    ["tarrying", "tar-ry-ing"],
    ["alive", "a-live"],
    ["sickness", "sick-ness"],
    ["sinned", "sinned"],
    ["die", "die"],
    ["conceiveth", "con-ceiv-eth"],
    ["whisper", "whis-per"],
    ["familiar", "fa-mi-li-ar"],
    ["raise", "raise"],
    ["favourest", "fa-vour-est"],
    ["upholdest", "up-hold-est"],
    ["amen", "a-men"],
    ["hart", "hart"],
    ["desireth", "de-sir-eth"],
    ["water-brooks", "wa-ter_brooks"],
    ["longeth", "long-eth"],
    ["athirst", "a-thirst"],
    ["appear", "ap-pear"],
    ["meat", "meat"],
    ["thereupon", "there-up-on"],
    ["pour", "pour"],
    ["holy-day", "ho-ly_day"],
    ["disquieted", "dis-qui-et-ed"],
    ["jordan", "jor-dan"],
    ["hermon", "her-mon"],
    ["calleth", "call-eth"],
    ["noise", "noise"],
    ["waves", "waves"],
    ["storms", "storms"],
    ["daytime", "day-time"],
    ["oppresseth", "op-press-eth"],
    ["namely", "name-ly"],
    ["told", "told"],
    ["flourish", "flou-rish"],
    ["arm", "arm"],
    ["hadst", "hadst"],
    ["overthrow", "o-ver-throw"],
    ["savest", "sav-est"],
    ["puttest", "putt-est"],
    ["goest", "goest"],
    ["armies", "arm-ies"],
    ["spoil", "spoil"],
    ["goods", "goods"],
    ["lettest", "lett-est"],
    ["sellest", "sell-est"],
    ["takest", "tak-est"],
    ["laughed", "laughed"],
    ["by-word", "by_word"],
    ["slanderer", "slan-der-er"],
    ["blasphemer", "blas-phe-mer"],
    ["ourselves", "our-selves"],
    ["frowardly", "fro-ward-ly"],
    ["steps", "steps"],
    ["dragons", "dra-gons"],
    ["holden", "hold-en"],
    ["strange", "strange"],
    ["secrets", "sec-rets"],
    ["killed", "killed"],
    ["appointed", "ap-poin-ted"],
    ["slain", "slain"],
    ["sleepest", "sleep-est"],
    ["absent", "ab-sent"],
    ["forgettest", "for-gett-est"],
    ["belly", "bel-ly"],
    ["overfloweth", "ov-er-flow-eth"],
    ["concerning", "con-cer-ning"],
    ["pen", "pen"],
    ["writer", "wri-ter"],
    ["fairer", "fair-er"],
    ["grace", "grace"],
    ["gird", "gird"],
    ["thigh", "thigh"],
    ["renown", "re-nown"],
    ["luck", "luck"],
    ["ride", "ride"],
    ["meekness", "meek-ness"],
    ["terrible", "ter-ri-ble"],
    ["sharp", "sharp"],
    ["kings", "kings"],
    ["subdued", "sub-dued"],
    ["sceptre", "scep-tre"],
    ["fellows", "fel-lows"],
    ["smell", "smell"],
    ["myrrh", "myrrh"],
    ["aloes", "al-oes"],
    ["cassia", "cas-si-a"],
    ["ivory", "i-vo-ry"],
    ["palaces", "pa-la-ces"],
    ["whereby", "where-by"],
    ["kings", "kings"],
    ["daughters", "daugh-ters"],
    ["honourable", "ho-nou-ra-ble"],
    ["women", "wo-men"],
    ["queen", "queen"],
    ["wrought", "wrought"],
    ["divers", "di-vers"],
    ["colours", "col-ours"],
    ["fathers", "fa-thers"],
    ["tyre", "tyre"],
    ["gift", "gift"],
    ["rich", "rich"],
    ["supplication", "supp-li-ca-tion"],
    ["clothing", "clo-thing"],
    ["raiment", "rai-ment"],
    ["needlework", "nee-dle-work"],
    ["virgins", "vir-gins"],
    ["company", "com-pa-ny"],
    ["enter", "en-ter"],
    ["palace", "pa-lace"],
    ["instead", "in-stead"],
    ["remembered", "re-mem-bered"],
    ["present", "pre-sent"],
    ["carried", "car-ried"],
    ["swell", "swell"],
    ["streams", "streams"],
    ["whereof", "where-of"],
    ["ado", "ado"],
    ["kingdoms", "king-doms"],
    ["melt", "melt"],
    ["hither", "hi-ther"],
    ["wars", "wars"],
    ["cease", "cease"],
    ["knappeth", "knapp-eth"],
    ["sunder", "sun-der"],
    ["burneth", "burn-eth"],
    ["clap", "clap"],
    ["melody", "me-lo-dy"],
    /////////
    ["feared", "feared"],
    ["subdue", "sub-due"],
    ["excellency", "ex-cell-en-cy"],
    ["merry", "mer-ry"],
    ["trump", "trump"],
    ["reigneth", "reign-eth"],
    ["joined", "joined"],
    ["abraham", "ab-ra-ham"],
    ["highly", "high-ly"],
    ["north", "north"],
    ["marvelled", "mar-velled"],
    ["astonished", "as-ton-ished"],
    ["sorrow", "sor-row"],
    ["woman", "wo-man"],
    ["ships", "ships"],
    ["east-wind", "east_wind"],
    ["worlds", "worlds"],
    ["mount", "mount"],
    ["judah", "ju-dah"],
    ["towers", "tow-ers"],
    ["mark", "mark"],
    ["bulwarks", "bul-warks"],
    ["muse", "muse"],
    ["parable", "pa-ra-ble"],
    ["heels", "heels"],
    ["compasseth", "com-pass-eth"],
    ["ransom", "ran-som"],
    ["for", "for"],
    ////////
    ["cost", "cost"],
    ["redeem", "re-deem"],
    ["alone", "a-lone"],
    ["ever", "ev-er"],
    ["ignorant", "ig-no-rant"],
    ["houses", "hou-ses"],
    ["dwelling-places", "dwell-ing_pla-ces"],
    ["being", "be-ing"],
    ["abideth", "ab-id-eth"],
    ["seeing", "see-ing"],
    ["compared", "comp-ared"],
    ["posterity", "pos-te-ri-ty"],
    ["carry", "car-ry"],
    ["dieth", "di-eth"],
    ["pomp", "pomp"],
    ["lived", "lived"],
    ["happy", "hap-py"],
    ["doest", "do-est"],
    ["spoken", "spo-ken"],
    ["rising", "ris-ing"],
    ["appeared", "ap-peared"],
    ["stirred", "stirred"],
    ["testify", "tes-ti-fy"],
    ["reprove", "re-prove"],
    ["sacrifices", "sac-ri-fi-ces"],
    ["burnt-offerings", "burnt_off-er-ings"],
    ["bullock", "bull-ock"],
    ["he-goats", "he_goats"],
    ["folds", "folds"],
    ["forest", "for-est"],
    ["cattle", "cat-tle"],
    ["thousand", "thou-sand"],
    ["wild", "wild"],
    ["hungry", "hun-gry"],
    ["thinkest", "think-est"],
    ["bulls", "bulls"],
    ["goats", "goats"],
    ["preach", "preach"],
    ["whereas", "where-as"],
    ["reformed", "re-formed"],
    ["behind", "be-hind"],
    ["sawest", "saw-est"],
    ["thief", "thief"],
    ["consentedst", "con-sent-edst"],
    ["partaker", "par-tak-er"],
    ["adulterers", "ad-ult-er-ers"],
    ["sattest", "satt-est"],
    ["spakest", "spak-est"],
    ["thoughtest", "thought-est"],
    ["wickedly", "wick-ed-ly"],
    ["offereth", "off-er-eth"],
    ["honoureth", "hon-our-eth"],
    ["aright", "a-right"],
    ["throughly", "through-ly"],
    ["acknowledge", "ack-now-ledge"],
    ["justified", "jus-ti-fied"],
    ["shapen", "sha-pen"],
    ["requirest", "re-quir-est"],
    ["purge", "purge"],
    ["hyssop", "hys-sop"],
    ["whiter", "whi-ter"],
    ["snow", "snow"],
    ["misdeeds", "mis-deeds"],
    ["renew", "re-new"],
    ["stablish", "stab-lish"],
    ["free", "free"],
    ["converted", "con-ver-ted"],
    ["blood-guiltiness", "blood_guil-ti-ness"],
    ["desirest", "de-sir-est"],
    ["delightest", "de-light-est"],
    ["despise", "des-pise"],
    ["walls", "walls"],
    ["jerusalem", "je-ru-sa-lem"],
    ["pleased", "pleased"],
    ["oblations", "ob-la-tions"],
    ["bullocks", "bull-ocks"],
    ["boastest", "boast-est"],
    ["tyrant", "ty-rant"],
    ["canst", "canst"],
    ["cuttest", "cutt-est"],
    ["razor", "ra-zor"],
    ["hurt", "hurt"],
    ["strengthened", "strength-en-ed"],
    ["olive-tree", "ol-ive_tree"],
    ["besieged", "be-sieged"],
    ["tyrants", "ty-rants"],
    ["uphold", "up-hold"],
    ["comfortable", "com-for-ta-ble"],
    ["mourn", "mourn"],
    ["minded", "min-ded"],
    ["maliciously", "ma-li-cious-ly"],
    ["fearfulness", "fear-ful-ness"],
    ["dread", "dread"],
    ["overwhelmed", "ov-er-whelmed"],
    ["dove", "dove"],
    ["escape", "es-cape"],
    ["stormy", "stor-my"],
    ["divide", "di-vide"],
    ["spied", "spied"],
    ["borne", "borne"],
    ["adversary", "ad-ver-sa-ry"],
    ["peradventure", "per-ad-ven-ture"],
    ["companion", "com-pan-ion"],
    ["sweet", "sweet"],
    ["friends", "friends"],
    ["hastily", "has-ti-ly"],
    ["dwellings", "dwell-ings"],
    ["evening", "eve-ning"],
    ["pray", "pray"],
    ["instantly", "in-stant-ly"],
    ["strove", "strove"],
    ["brake", "brake"],
    ["softer", "sof-ter"],
    ["butter", "but-ter"],
    ["having", "hav-ing"],
    ["smoother", "smooth-er"],
    ["swords", "swords"],
    ["nourish", "nour-ish"],
    ["half", "half"],
    ["fighting", "fight-ing"],
    ["troubling", "troubl-ing"],
    ["swallow", "swal-low"],
    /////////
    ["sometime", "some-time"],
    ["mistake", "mis-take"],
    ["tellest", "tell-est"],
    ["wanderings", "wan-der-ings"],
    ["bottle", "bot-tle"],
    ["noted", "not-ed"],
    ["whensoever", "when-so-ev-er"],
    ["gods", "gods"],
    ["falling", "fall-ing"],
    ["tyranny", "ty-ran-ny"],
    ["overpast", "ov-er-past"],
    ["reproof", "re-proof"],
    ["spears", "spears"],
    ["pressed", "pressed"],
    ["fixed", "fixed"],
    ["greatness", "great-ness"],
    ["minds", "minds"],
    ["deal", "deal"],
    ["astray", "as-tray"],
    ["venomous", "ve-no-mous"],
    ["poison", "poi-son"],
    ["serpent", "ser-pent"],
    ["adder", "add-er"],
    ["stoppeth", "stopp-eth"],
    ["refuseth", "re-fus-eth"],
    ["charmer", "char-mer"],
    ["charm", "charm"],
    ["jaw-bones", "jaw_bones"],
    ["apace", "ap-ace"],
    ["snail", "snail"],
    ["untimely", "un-time-ly"],
    ["pots", "pots"],
    ["thorns", "thorns"],
    ["whirlwind", "whirl-wind"],
    ["burning", "burn-ing"],
    ["alike", "a-like"],
    ["vengeance", "ven-geance"],
    ["doubtless", "doubt-less"],
    ["judgeth", "judg-eth"],
    ["fault", "fault"],
    ["fro", "fro"],
    ["grin", "grin"],
    ["scatter", "scat-ter"],
    ["abroad", "a-broad"],
    ["return", "re-turn"],
    ["here", "here"],
    ["grudge", "grudge"],
    ["displeased", "dis-pleased"],
    ["divided", "di-vi-ded"],
    ["sores", "sores"],
    ["deadly", "dead-ly"],
    ["token", "to-ken"],
    ["beloved", "be-lov-ed"],
    ["shechem", "she-chem"],
    ["mete", "mete"],
    ["succoth", "succ-oth"],
    ["gilead", "gi-le-ad"],
    ["manasseh", "ma-na-sseh"],
    ["ephraim", "eph-ra-im"],
    ["law-giver", "law_gi-ver"],
    ["moab", "mo-ab"],
    ["wash-pot", "wash_pot"],
    ["edom", "e-dom"],
    ["shoe", "shoe"],
    ["philistia", "phil-is-ti-a"],
    ["acts", "acts"],
    ["crying", "cry-ing"],
    ["higher", "high-er"],
    ["tower", "tow-er"],
    ["covering", "co-ver-ing"],
    ["desires", "de-sires"],
    ["throughout", "through-out"],
    ["generations", "gen-er-a-tions"],
    ["waiteth", "wait-eth"],
    ["sort", "sort"],
    ["tottering", "tot-ter-ing"],
    ["hedge", "hedge"],
    ["exalt", "ex-alt"],
    ["curse", "curse"],
    ["weights", "weights"],
    ["lighter", "light-er"],
    ["itself", "it-self"],
    ["robbery", "robb-e-ry"],
    ["yourselves", "your-selves"],
    ["once", "once"],
    ["twice", "twice"],
    ["rewardest", "re-ward-est"],
    ["thirsteth", "thirst-eth"],
    ["barren", "bar-ren"],
    ["dry", "dry"],
    ["marrow", "mar-row"],
    ["fatness", "fat-ness"],
    ["praiseth", "prais-eth"],
    ["thought", "thought"],
    ["waking", "wak-ing"],
    ["hangeth", "hang-eth"],
    ["upholden", "up-hold-en"],
    ["edge", "edge"],
    ["foxes", "fox-es"],
    ["swear", "swear"],
    ["commended", "com-men-ded"],
    ["stopped", "stopped"],
    ["gathering", "gath-er-ing"],
    ["insurrection", "in-sur-rec-tion"],
    ["bitter", "bit-ter"],
    ["hit", "hit"],
    ["encourage", "en-cour-age"],
    ["practise", "prac-tise"],
    ["swift", "swift"],
    ["arrow", "ar-row"],
    ["wounded", "woun-ded"],
    ["insomuch", "in-so-much"],
    ["perceive", "per-ceive"],
    ["vow", "vow"],
    ["performed", "per-formed"],
    ["choosest", "choos-est"],
    ["receivest", "re-ceiv-est"],
    ["court", "court"],
    ["wonderful", "won-der-ful"],
    ["broad", "broad"],
    ["stilleth", "still-eth"],
    ["raging", "rag-ing"],
    ["madness", "mad-ness"],
    ["tokens", "tok-ens"],
    ["out-goings", "out_go-ings"],
    ["blessest", "bless-est"],
    ["plenteous", "plen-te-ous"],
    ["providest", "pro-vi-dest"],
    ["waterest", "wa-ter-est"],
    ["furrows", "furr-ows"],
    ["sendest", "send-est"],
    ["valleys", "vall-eys"],
    ["soft", "soft"],
    ["drops", "drops"],
    ["crownest", "crown-est"],
    ["year", "year"],
    ["drop", "drop"],
    ["holdeth", "hold-eth"],
    ["suffereth", "suff-er-eth"],
    ["broughtest", "brought-est"],
    ["snare", "snare"],
    ["laidest", "laid-est"],
    ["sufferedst", "suffer-edst"],
    ["wealthy", "weal-thy"],
    ["promised", "prom-ised"],
    ["burnt-sacrifices", "burnt_sac-ri-fi-ces"],
    ["incense", "in-cense"],
    ["rams", "rams"],
    ["bless", "bless"],
    ["saving", "sav-ing"],
    ["righteously", "right-eous-ly"],
    ["govern", "gov-ern"],
    ["vanisheth", "van-ish-eth"],
    ["drive", "drive"],
    ["melteth", "melt-eth"],
    ["rideth", "rid-eth"],
    ["jah", "jah"],
    ["defendeth", "de-fend-eth"],
    ["widows", "wid-ows"],
    ["prisoners", "pris-on-ers"],
    ["letteth", "let-teth"],
    ["runagates", "run-a-gates"],
    ["scarceness", "scarce-ness"],
    ["wentest", "went-est"],
    ["dropped", "dropped"],
    ["sinai", "si-nai"],
    ["sentest", "sent-est"],
    ["refreshedst", "ref-resh-edst"],
    ["tidings", "tid-ings"],
    //////
    ["discomfited", "dis-com-fit-ed"],
    ["household", "house-hold"],
    ["lain", "lain"],
    ["sheep-folds", "sheep_folds"],
    ["feathers", "feath-ers"],
    ["almighty", "al-migh-ty"],
    ["white", "white"],
    ["salmon", "sal-mon"],
    ["pleaseth", "pleas-eth"],
    ["twenty", "twen-ty"],
    ["led", "led"],
    ["captive", "cap-tive"],
    ["received", "re-ceived"],
    ["poureth", "pour-eth"],
    ["benefits", "be-ne-fits"],
    ["wound", "wound"],
    ["hairy", "hai-ry"],
    ["scalp", "scalp"],
    ["dipped", "dipped"],
    ["red", "red"],
    ["singers", "sing-ers"],
    ["minstrels", "min-strels"],
    ["damsels", "dam-sels"],
    ["playing", "play-ing"],
    ["timbrels", "tim-brels"],
    ["fountain", "foun-tain"],
    ["benjamin", "ben-ja-min"],
    ["ruler", "ru-ler"],
    ["zebulon", "ze-bu-lon"],
    ["naphthali", "naph-tha-li"],
    ["temples", "temples"],
    ["presents", "pres-ents"],
    ["dragon", "dra-gon"],
    ["bull", "bull"],
    ["leaders", "lead-ers"],
    ["egypt", "egypt"],
    ["morians", "mo-ri-ans"],
    ["stretch", "stretch"],
    ["beginning", "be-ginn-ing"],
    ["guiltless", "guilt-less"],
    ["paid", "paid"],
    ["simpleness", "sim-ple-ness"],
    ["suffered", "suff-ered"],
    ["alien", "a-li-en"],
    ["zeal", "zeal"],
    ["wept", "wept"],
    ["chastened", "chast-ened"],
    ["jested", "jes-ted"],
    ["gate", "gate"],
    ["drunkards", "drunk-ards"],
    ["sink", "sink"],
    ["drown", "drown"],
    ["pity", "pi-ty"],
    ["gall", "gall"],
    ["thirsty", "thirs-ty"],
    ["vinegar", "vi-ne-gar"],
    ["withal", "with-al"],
    ["wealth", "wealth"],
    ["blinded", "blin-ded"],
    ["wrathful", "wrath-ful"],
    ["void", "void"],
    ["tents", "tents"],
    ["wiped", "wiped"],
    ["please", "please"],
    ["hoofs", "hoofs"],
    ["despiseth", "des-pis-eth"],
    ["moveth", "mov-eth"],
    ["stronghold", "strong-hold"],
    ["whereunto", "where-un-to"],
    ["resort", "res-ort"],
    ["monster", "mon-ster"],
    ["gray-headed", "gray_head-ed"],
    ["refresh", "ref-resh"],
    ["comforted", "com-for-ted"],
    ["music", "mu-sic"],
    ["mown", "mown"],
    ["abundance", "ab-un-dance"],
    ["lick", "lick"],
    ["tarshish", "tar-shish"],
    ["isles", "isles"],
    ["arabia", "a-ra-bi-a"],
    ["saba", "sa-ba"],
    ["service", "ser-vice"],
    ["dear", "dear"],
    ["posterities", "pos-te-ri-ties"],
    ["majesty", "ma-jes-ty"],
    ["almost", "al-most"],
    ["treadings", "tread-ings"],
    ["well-nigh", "well_nigh"],
    ["grieved", "grieved"],
    ["peril", "pe-ril"],
    ["lusty", "lus-ty"],
    ["plagued", "plagued"],
    ["cruelty", "cruel-ty"],
    ["covereth", "co-ver-eth"],
    ["thereout", "there-out"],
    ["suck", "suck"],
    ["advantage", "ad-van-tage"],
    ["cleansed", "cleansed"],
    ["washed", "washed"],
    ["condemned", "con-demned"],
    ["understood", "un-der-stood"],
    ["castest", "cast-est"],
    ["destroyest", "des-troy-est"],
    ["fearful", "fear-ful"],
    ["dream", "dream"],
    ["awaketh", "a-wak-eth"],
    ["image", "im-age"],
    ["vanish", "van-ish"],
    ["comparison", "com-pa-ri-son"],
    ["unfaithful", "un-faith-ful"],
    ["purchased", "purch-ased"],
    ["tribe", "tribe"],
    ["roar", "roar"],
    ["banners", "ban-ners"],
    ["hewed", "hewed"],
    ["timber", "tim-ber"],
    ["afore", "a-fore"],
    ["trees", "trees"],
    ["carved", "carved"],
    ["axes", "axes"],
    ["hammers", "ham-mers"],
    ["defiled", "de-filed"],
    ["dwelling-place", "dwell-ing_place"],
    ["havoc", "hav-oc"],
    ["burnt", "burnt"],
    ["prophet", "pro-phet"],
    ["withdrawest", "with-draw-est"],
    ["pluckest", "pluck-est"],
    ["brakest", "brak-est"],
    ["smotest", "smot-est"],
    ["leviathan", "le-vi-a-than"],
    ["fountains", "foun-tains"],
    ["rocks", "rocks"],
    ["driedst", "driedst"],
    ["borders", "bor-ders"],
    ["winter", "win-ter"],
    ["blasphemed", "blas-phemed"],
    ["turtle-dove", "tur-tle_dove"],
    ["habitations", "ha-bi-ta-tions"],
    ["blasphemeth", "blas-phem-eth"],
    ["presumption", "pre-sump-tion"],
    ["increaseth", "in-creas-eth"],
    ["inhabiters", "in-hab-it-ers"],
    ["pillars", "pill-ars"],
    ["fools", "fools"],
    ["madly", "mad-ly"],
    ["stiff", "stiff"],
    ["neck", "neck"],
    ["promotion", "pro-mo-tion"],
    ["east", "east"],
    ["west", "west"],
    ["south", "south"],
    ["mixt", "mixt"],
    ["dregs", "dregs"],
    ["salem", "sa-lem"],
    ["comest", "com-est"],
    ["robbers", "rob-bers"],
    ["robbed", "robbed"],
    ["chariot", "cha-ri-ot"],
    ["arose", "ar-ose"],
    ["fierceness", "fierce-ness"],
    ["promise", "prom-ise"],
    ["stretched", "stretched"],
    ["refused", "re-fused"],
    ["complain", "com-plain"],
    ["holdest", "hold-est"],
    ["past", "past"],
    ["intreated", "in-treat-ed"],
    ["infirmity", "in-fir-mi-ty"],
    ["wonders", "won-ders"],
    ["mightily", "migh-ti-ly"],
    ["joseph", "jo-seph"],
    ["depths", "depths"],
    ["shone", "shone"],
    ["leddest", "ledd-est"],
    ["moses", "mo-ses"],
    ["aaron", "aa-ron"],
    ["sentences", "sen-ten-ces"],
    ["forefathers", "fore-fathers"],
    ["unborn", "un-born"],
    ["intent", "in-tent"],
    ["faithless", "faith-less"],
    ["stubborn", "stub-born"],
    ["clave", "clave"],
    ["stedfastly", "sted-fast-ly"],
    ["harnessed", "harn-essed"],
    ["carrying", "car-ry-ing"],
    ["bows", "bows"],
    ["forgat", "for-gat"],
    ["zoan", "zo-an"],
    ["cloud", "cloud"],
    ["depth", "depth"],
    ["gushed", "gushed"],
    ["rivers", "ri-vers"],
    ["tempted", "tempt-ed"],
    ["smote", "smote"],
    ["indeed", "in-deed"],
    ["flowed", "flowed"],
    ["provide", "pro-vide"],
    ["believed", "be-lieved"],
    ["rained", "rained"],
    ["manna", "man-na"],
    ["food", "food"],
    ["angels", "an-gels"],
    ["caused", "caused"],
    ["blow", "blow"],
    ["southwest-wind", "south-west_wind"],
    ["feathered", "feath-ered"],
    ["sand", "sand"],
    ["disappointed", "dis-ap-point-ed"],
    ["slew", "slew"],
    ["wealthiest", "wealth-i-est"],
    ["inquired", "in-quired"],
    ["dissembled", "dis-sem-bled"],
    ["continued", "con-tin-ued"],
    ["stedfast", "sted-fast"],
    ["forgave", "for-gave"],
    ["passeth", "pass-eth"],
    ["provoke", "pro-voke"],
    ["desert", "des-ert"],
    ["miracles", "mi-ra-cles"],
    ["flies", "flies"],
    ["frogs", "frogs"],
    ["caterpillar", "ca-ter-pil-lar"],
    ["labour", "la-bour"],
    ["grasshopper", "grass-hop-per"],
    ["vines", "vines"],
    ["mulberry-trees", "mul-ber-ry-trees"],
    ["frost", "frost"],
    ["flocks", "flocks"],
    ["thunderbolts", "thun-der-bolts"],
    ["furiousness", "fu-ri-ous-ness"],
    ["spared", "spared"],
    ["pestilence", "pes-til-ence"],
    ["firstborn", "first-born"],
    ["principal", "prin-ci-pal"],
    ["mightiest", "migh-ti-est"],
    ["ham", "ham"],
    ["flock", "flock"],
    ["safely", "safe-ly"],
    ["mountain", "moun-tain"],
    ["tribes", "tribes"],
    ["starting", "start-ing"],
    ["aside", "as-ide"],
    ["hill-altars", "hill_alt-ars"],
    ["images", "im-a-ges"],
    ["forsook", "for-sook"],
    ["shiloh", "shi-loh"],
    ["tent", "tent"],
    ["pitched", "pitched"],
    ["enemys", "e-ne-mys"],
    ["maidens", "maid-ens"],
    ["marriage", "mar-riage"],
    ["priests", "priests"],
    ["lamentation", "lam-en-ta-tion"],
    ["awaked", "a-waked"],
    ["drave", "drave"],
    ["chose", "chose"],
    ["built", "built"],
    ["foundation", "foun-da-tion"],
    ["continually", "con-ti-nu-al-ly"],
    ["following", "fol-low-ing"],
    ["ewes", "ewes"],
    ["ruled", "ruled"],
    ["prudently", "pru-dent-ly"],
    ["stones", "stones"],
    ["bodies", "bod-ies"],
    ["shed", "shed"],
    ["bury", "bu-ry"],
    ["jealousy", "jea-lou-sy"],
    ["burn", "burn"],
    ["waste", "waste"],
    ["servants", "ser-vants"],
    ["openly", "o-pen-ly"],
    ["sorrowful", "sor-row-ful"],
    ["wherewith", "where-with"],
    ["sevenfold", "sev-en-fold"],
    ["showing", "show-ing"],
    ["leadest", "lead-est"],
    ["sittest", "sitt-est"],
    ["stir", "stir"],
    ["prayeth", "pray-eth"],
    ["feedest", "feed-est"],
    ["givest", "giv-est"],
    ["vine", "vine"],
    ["boughs", "boughs"],
    ["branches", "branch-es"],
    ["grapes", "grapes"],
    ["boar", "boar"],
    ["wood", "wood"],
    ["vineyard", "vine-yard"],
    ["branch", "branch"],
    ["self", "self"],
    ["merrily", "mer-ri-ly"],
    ["cheerful", "cheer-ful"],
    ["tabret", "tab-ret"],
    ["trumpet", "trum-pet"],
    ["solemn", "sol-emn"],
    ["feast-day", "feast_day"],
    ["statute", "stat-ute"],
    ["eased", "eased"],
    ["shoulder", "shoul-der"],
    ["calledst", "call-edst"],
    ["assure", "ass-ure"],
    ["wide", "wide"],
    ["fill", "fill"],
    ["hearts", "hearts"],
    ["lusts", "lusts"],
    ["hearkened", "heark-en-ed"],
    ["haters", "hat-ers"],
    ["submitted", "sub-mit-ted"],
    ["endured", "en-dured"],
    ["finest", "fin-est"],
    ["wheatflour", "wheat-flour"],
    ["gods", "gods"],
    ["need", "need"],
    ["necessity", "ne-ces-si-ty"],
    ["murmuring", "mur-mur-ing"],
    ["craftily", "craf-ti-ly"],
    ["ones", "ones"],
    ["consent", "con-sent"],
    ["confederate", "con-fed-er-ate"],
    ["tabernacles", "ta-ber-na-cles"],
    ["edomites", "e-dom-ites"],
    ["ishmaelites", "ish-mael-ites"],
    ["moabites", "mo-a-bites"],
    ["hagarenes", "ha-ga-renes"],
    ["gebal", "ge-bal"],
    ["ammon", "am-mon"],
    ["amalek", "a-ma-lek"],
    ["philistines", "phi-li-stines"],
    ["assyria", "as-sy-ria"],
    ["midianites", "mi-di-an-ites"],
    ["sisera", "si-se-ra"],
    ["jabin", "ja-bin"],
    ["brook", "brook"],
    ["kishon", "ki-shon"],
    ["endor", "en-dor"],
    ["dung", "dung"],
    ["oreb", "or-eb"],
    ["zeeb", "ze-eb"],
    ["zebah", "ze-bah"],
    ["zalmunna", "zal-mun-na"],
    ["whirling", "whirl-ing"],
    ["stubble", "stub-ble"],
    ["flame", "flame"],
    ["consumeth", "con-sum-eth"],
    ["amiable", "a-mi-able"],
    ["longing", "long-ing"],
    ["courts", "courts"],
    ["sparrow", "spar-row"],
    ["nest", "nest"],
    ["altars", "alt-ars"],
    ["praising", "prais-ing"],
    ["vale", "vale"],
    ["use", "use"],
    ["pools", "pools"],
    ["appeareth", "ap-pear-eth"],
    ["rather", "ra-ther"],
    ["door-keeper", "door_kee-per"],
    ["withhold", "with-hold"],
    ["quicken", "quick-en"],
    ["met", "met"],
    ["kissed", "kissed"],
    ["each", "each"],
    ["glorify", "glo-ri-fy"],
    ["knit", "knit"],
    ["nethermost", "neth-er-most"],
    ["violent", "vio-lent"],
    ["compassion", "com-pass-ion"],
    ["long-suffering", "long_suf-fer-ing"],
    ["handmaid", "hand-maid"],
    ["babylon", "ba-by-lon"],
    ["ethiopia", "eth-i-op-ia"],
    ["reported", "re-por-ted"],
    ["record", "re-cord"],
    ["writeth", "writ-eth"],
    ["trumpeters", "trump-et-ers"],
    ["fresh", "fresh"],
    ["draweth", "draw-eth"],
    ["lowest", "low-est"],
    ["prison", "pri-son"],
    ["abhorrest", "ab-horr-est"],
    ["point", "point"],
    ["terrors", "terr-ors"],
    ["undone", "un-done"],
    ["rulest", "rul-est"],
    ["stillest", "still-est"],
    ["tabor", "ta-bor"],
    ["equity", "eq-ui-ty"],
    ["visions", "vis-ions"],
    ["saidst", "saidst"],
    ["violence", "vio-lence"],
    ["scourges", "scour-ges"],
    ["alter", "al-ter"],
    ["witness", "wit-ness"],
    ["overthrown", "ov-er-thrown"],
    ["hedges", "hed-ges"],
    ["victory", "vic-to-ry"],
    ["shortened", "short-ened"],
    ["short", "short"],
    ["swarest", "swar-est"],
    ["turnest", "turn-est"],
    ["sayest", "say-est"],
    ["yesterday", "yes-ter-day"],
    ["watch", "watch"],
    ["scatterest", "scat-ter-est"],
    ["fade", "fade"],
    ["groweth", "grow-eth"],
    ["tale", "tale"],
    ["threescore", "three-score"],
    ["fourscore", "four-score"],
    ["regardeth", "re-gard-eth"],
    ["apply", "ap-ply"],
    ["satisfy", "sat-is-fy"],
    ["hunter", "hun-ter"],
    ["noisome", "noi-some"],
    ["terror", "terr-or"],
    ["flieth", "fli-eth"],
    ["destroyeth", "des-troy-eth"],
    ["loud", "loud"],
    ["operations", "op-er-a-tions"],
    ["unwise", "un-wise"],
    ["palm-tree", "palm_tree"],
    ["spread", "spread"],
    ["cedar", "ce-dar"],
    ["well-liking", "well_li-king"],
    ["apparel", "ap-pa-rel"],
    ["began", "be-gan"],
    ["horribly", "hor-ri-bly"],
    ["mightier", "migh-ti-er"],
    ["deserving", "des-erv-ing"],
    ["boasting", "boast-ing"],
    ["widow", "wid-ow"],
    ["instructeth", "in-struct-eth"],
    ["chastenest", "chast-en-est"],
    ["teachest", "teach-est"],
    ["patience", "pa-tience"],
    ["comforts", "com-forts"],
    ["confidence", "con-fi-dence"],
    ["malice", "ma-lice"],
    ["heartily", "hear-ti-ly"],
    ["maker", "ma-ker"],
    ["to-day", "to_day"],
    ["harden", "har-den"],
    ["provocation", "pro-vo-ca-tion"],
    ["temptation", "temp-ta-tion"],
    ["forty", "for-ty"],
    ["err", "err"],
    ["sware", "sware"],
    ["telling", "tell-ing"],
    ["worthily", "wor-thi-ly"],
    ["praised", "praised"],
    ["idols", "i-dols"],
    ["shine", "shine"],
    ["melted", "mel-ted"],
    ["sprung", "sprung"],
    ["true-hearted", "true_heart-ed"],
    ["gotten", "got-ten"],
    ["trumpets", "trum-pets"],
    ["shawms", "shawms"],
    ["impatient", "im-pa-tient"],
    ["between", "bet-ween"],
    ["unquiet", "un-qui-et"],
    ["executed", "ex-e-cut-ed"],
    ["footstool", "foot-stool"],
    ["samuel", "sam-u-el"],
    ["cloudy", "clou-dy"],
    ["pillar", "pil-lar"],
    ["godliness", "god-li-ness"],
    ["unfaithfulness", "un-faith-ful-ness"],
    ["cleave", "cleave"],
    ["depart", "de-part"],
    ["person", "per-son"],
    ["slandereth", "slan-der-eth"],
    ["haughty", "haugh-ty"],
    ["firebrand", "fireb-rand"],
    ["scarce", "scarce"],
    ["pelican", "pel-i-can"],
    ["owl", "owl"],
    ["watched", "watched"],
    ["housetop", "house-top"],
    ["revile", "re-vile"],
    ["mad", "mad"],
    ["ashes", "ash-es"],
    ["mingled", "ming-led"],
    ["pitieth", "pi-ti-eth"],
    ["mournings", "mourn-ings"],
    ["journey", "journ-ey"],
    ["change", "change"],
    ["changed", "changed"],
    ["forgiveth", "for-giv-eth"],
    ["healeth", "heal-eth"],
    ["infirmities", "in-fir-mi-ties"],
    ["crowneth", "crown-eth"],
    ["satisfieth", "sa-tis-fi-eth"],
    ["eagle", "eagle"],
    ["executeth", "ex-e-cut-eth"],
    ["longsuffering", "long-suff-er-ing"],
    ["flourisheth", "flour-ish-eth"],
    ["flower", "flow-er"],
    ["childrens", "child-rens"],
    ["deckest", "deck-est"],
    ["spreadest", "spread-est"],
    ["curtain", "cur-tain"],
    ["beams", "beams"],
    ["chambers", "cham-bers"],
    ["winds", "winds"],
    ["ministers", "mi-ni-sters"],
    ["flaming", "flam-ing"],
    ["move", "move"],
    ["coveredst", "cov-eredst"],
    ["beneath", "be-neath"],
    ["bounds", "bounds"],
    ["sendeth", "send-eth"],
    ["asses", "ass-es"],
    ["quench", "quench"],
    ["thirst", "thirst"],
    ["watereth", "wa-ter-eth"],
    ["sap", "sap"],
    ["birds", "birds"],
    ["nests", "nests"],
    ["firtrees", "fir-trees"],
    ["stork", "stork"],
    ["conies", "con-ies"],
    ["certain", "cer-tain"],
    ["seasons", "sea-sons"],
    ["ariseth", "a-ris-eth"],
    ["manifold", "ma-ni-fold"],
    ["creeping", "creep-ing"],
    ["pastime", "pas-time"],
    ["openest", "o-pen-est"],
    /////
    ["tremble", "trem-ble"],
    ["touch", "touch"],
    ["oath", "oath"],
    ["isaac", "i-saac"],
    ["testament", "tes-ta-ment"],
    ["canaan", "ca-naan"],
    ["few", "few"],
    ["nation", "na-tion"],
    ["reproved", "re-proved"],
    ["prophets", "pro-phets"],
    ["provision", "pro-vis-ion"],
    ["sold", "sold"],
    ["bond-servant", "bond_ser-vant"],
    ["stocks", "stocks"],
    ["prince", "prince"],
    ["senators", "se-na-tors"],
    ["exceedingly", "ex-ceed-ing-ly"],
    ["stronger", "stron-ger"],
    ["untruly", "un-tru-ly"],
    ["obedient", "o-be-di-ent"],
    ["fish", "fish"],
    ["lice", "lice"],
    ["quarters", "quar-ters"],
    ["fig-trees", "fig_trees"],
    ["coasts", "coasts"],
    ["grasshoppers", "grass-hop-pers"],
    ["caterpillars", "ca-ter-pil-lars"],
    ["chief", "chief"],
    ["departing", "de-part-ing"],
    ["quails", "quails"],
    ["ran", "ran"],
    ["labours", "la-bours"],
    ["observe", "ob-serve"],
    ["noble", "no-ble"],
    ["bearest", "bear-est"],
    ["amiss", "a-miss"],
    ["regarded", "re-gar-ded"],
    ["disobedient", "dis-o-be-di-ent"],
    ["adversarys", "ad-ver-sa-rys"],
    ["sang", "sang"],
    ["leanness", "lean-ness"],
    ["angered", "an-gered"],
    ["saint", "saint"],
    ["swallowed", "swal-lowed"],
    ["dathan", "da-than"],
    ["abiram", "ab-i-ram"],
    ["horeb", "ho-reb"],
    ["molten", "mol-ten"],
    ["similitude", "si-mi-li-tude"],
    ["eateth", "eat-eth"],
    ["hay", "hay"],
    ["gap", "gap"],
    ["pleasant", "plea-sant"],
    ["credence", "cred-ence"],
    ["murmured", "mur-mured"],
    ["baal-peor", "baal_pe-or"],
    ["ate", "ate"],
    ["phinehas", "phi-ne-has"],
    ["interposed", "in-ter-posed"],
    ["unadvisedly", "un-ad-vi-sed-ly"],
    ["learned", "learned"],
    ["offered", "off-ered"],
    ["devils", "dev-ils"],
    ["stained", "stained"],
    ["whoring", "whor-ing"],
    ["lords", "lords"],
    ["pitied", "pit-ied"],
    ["distress", "dist-ress"],
    ["empty", "emp-ty"],
    ["filleth", "fil-leth"],
    ["bound", "bound"],
    ["lightly", "light-ly"],
    ["brass", "brass"],
    ["bars", "bars"],
    ["deaths", "deaths"],
    ["door", "door"],
    ["occupy", "oc-cu-py"],
    ["business", "busi-ness"],
    ["lifteth", "lift-eth"],
    ["reel", "reel"],
    ["stagger", "stag-ger"],
    ["drunken", "drunk-en"],
    ["wits", "wits"],
    ["haven", "ha-ven"],
    ["elders", "eld-ers"],
    ["drieth", "dri-eth"],
    ["water-springs", "wa-ter_springs"],
    ["fruitful", "fruit-ful"],
    ["standing", "stand-ing"],
    ["sow", "sow"],
    ["plant", "plant"],
    ["vineyards", "vine-yards"],
    ["yield", "yield"],
    ["fruits", "fruits"],
    ["blesseth", "bles-seth"],
    ["multiply", "mul-ti-ply"],
    ["decrease", "de-crease"],
    ["oppression", "opp-ress-ion"],
    ["entreated", "en-treat-ed"],
    ["wander", "wan-der"],
    ["households", "house-holds"],
    ["best", "best"],
    ["member", "mem-ber"],
    ["greater", "great-er"],
    ["lawgiver", "law-giv-er"],
    ["hatred", "hat-red"],
    ["fought", "fought"],
    ["contrary", "con-tra-ry"],
    ["office", "off-ice"],
    ["wife", "wife"],
    ["vagabonds", "va-ga-bonds"],
    ["beg", "beg"],
    ["extortioner", "ex-tor-tion-er"],
    ["next", "next"],
    ["persecuted", "per-se-cu-ted"],
    ["helpless", "help-less"],
    ["bowels", "bow-els"],
    ["cloak", "cloak"],
    ["girdle", "gir-dle"],
    ["departeth", "de-par-teth"],
    ["knees", "knees"],
    ["willingly", "will-ing-ly"],
    ["dew", "dew"],
    ["repent", "re-pent"],
    ["priest", "priest"],
    ["order", "or-der"],
    ["melchizedek", "mel-chi-ze-dek"],
    ["countries", "coun-tries"],
    ["verity", "ve-ri-ty"],
    ["redemption", "re-demp-tion"],
    ["reverend", "re-ver-end"],
    ["thereafter", "there-af-ter"],
    ["discretion", "dis-cre-tion"],
    ["believeth", "be-liev-eth"],
    ["shrink", "shrink"],
    ["dispersed", "dis-persed"],
    ["gnash", "gnash"],
    ["fled", "fled"],
    ["skipped", "skipped"],
    ["aileth", "ail-eth"],
    ["fleddest", "fled-dest"],
    ["water", "wa-ter"],
    ["flint-stone", "flint_stone"],
    ["springing", "spring-ing"],
    ["truths", "truths"],
    ["mens", "mens"],
    ["noses", "no-ses"],
    ["handle", "han-dle"],
    ["beseech", "be-seech"],
    ["liars", "li-ars"],
    ["bees", "bees"],
    ["extinct", "ex-tinct"],
    ["thrust", "thrust"],
    ["pre-eminence", "pre_em-in-ence"],
    ["corrected", "cor-rec-ted"],
    ["builders", "build-ers"],
    ["head-stone", "head_stone"],
    ["comer", "com-er"],
    ["wished", "wished"],
    ["bind", "bind"],
    ["charged", "charged"],
    ["diligently", "di-li-gent-ly"],
    ["unfeigned", "un-feigned"],
    ["wherewithal", "where-with-al"],
    ["ruling", "rul-ing"],
    ["fervent", "fer-vent"],
    ["occupied", "oc-cu-pied"],
    ["counsellors", "coun-sel-lors"],
    ["stuck", "stuck"],
    ["confound", "con-found"],
    ["covetousness", "co-ve-tous-ness"],
    ["blasphemers", "blas-phem-ers"],
    ["study", "stu-dy"],
    ["shrinked", "shrinked"],
    ["pilgrimage", "pil-grim-age"],
    ["prolonged", "pro-longed"],
    ["midnight", "mid-night"],
    ["graciously", "gra-cious-ly"],
    ["brawn", "brawn"],
    ["dearer", "dea-rer"],
    ["fashioned", "fash-ioned"],
    ["longed", "longed"],
    ["eyes-long", "eyes_long"],
    ["pits", "pits"],
    ["falsely", "false-ly"],
    ["ordinance", "ord-in-ance"],
    ["wiser", "wis-er"],
    ["teachers", "teach-ers"],
    ["aged", "aged"],
    ["refrained", "ref-rained"],
    ["shrunk", "shrunk"],
    ["lantern", "lant-ern"],
    ["measure", "meas-ure"],
    ["free-will", "free_will"],
    ["swerved", "swerved"],
    ["claimed", "claimed"],
    ["applied", "app-lied"],
    ["trodden", "trod-den"],
    ["dross", "dross"],
    ["trembleth", "tremb-leth"],
    ["lawful", "law-ful"],
    ["oppressors", "opp-ress-ors"],
    ["wasted", "wast-ed"],
    ["precious", "prec-ious"],
    ["straight", "straight"],
    ["drew", "drew"],
    ["usest", "us-est"],
    ["wrongful", "wrong-ful"],
    ["dealings", "deal-ings"],
    ["gush", "gush"],
    ["reputation", "re-pu-ta-tion"],
    ["prevent", "pre-vent"],
    ["watches", "watch-es"],
    ["lovingkindness", "lov-ing-kind-ness"],
    ["grounded", "groun-ded"],
    ["wont", "wont"],
    ["swerve", "swerve"],
    ["grieveth", "griev-eth"],
    ["findeth", "find-eth"],
    ["spoils", "spoils"],
    ["stumbling", "stum-bling"],
    ["lost", "lost"],
    ["woe", "woe"],
    ["constrained", "con-strained"],
    ["meshech", "mesh-ech"],
    ["kedar", "ke-dar"],
    ["whence", "whence"],
    ["slumber", "slum-ber"],
    ["keeper", "keep-er"],
    ["unity", "u-ni-ty"],
    ["thither", "thi-ther"],
    ["companions", "com-pan-ions"],
    ["dwellest", "dwell-est"],
    ["masters", "mas-ters"],
    ["maiden", "mai-den"],
    ["mistress", "mis-tress"],
    ["despitefulness", "des-pite-ful-ness"],
    ["wrathfully", "wrath-ful-ly"],
    ["drowned", "drowned"],
    ["stream", "stream"],
    ["escaped", "es-caped"],
    ["fowler", "fow-ler"],
    ["laughter", "laugh-ter"],
    ["already", "al-ready"],
    ["reap", "reap"],
    ["beareth", "bear-eth"],
    ["sheaves", "sheaves"],
    ["watchman", "watch-man"],
    ["waketh", "wak-eth"],
    ["late", "late"],
    ["carefulness", "care-ful-ness"],
    ["olive-branches", "ol-ive_branches"],
    ["plowers", "plo-wers"],
    ["plowed", "plowed"],
    ["hewn", "hewn"],
    ["housetops", "house-tops"],
    ["withereth", "with-er-eth"],
    ["grown", "grown"],
    ["mower", "mo-wer"],
    ["bindeth", "bind-eth"],
    ["extreme", "ext-reme"],
    ["fleeth", "fleeth"],
    ["high-minded", "high_min-ded"],
    ["matters", "mat-ters"],
    ["child", "child"],
    ["weaned", "weaned"],
    ["vowed", "vowed"],
    ["climb", "climb"],
    ["temples", "temp-les"],
    ["ephratah", "eph-ra-tah"],
    ["resting-place", "res-ting_place"],
    ["ark", "ark"],
    ["joyfulness", "joy-ful-ness"],
    ["davids", "da-vids"],
    ["victuals", "vic-tu-als"],
    ["deck", "deck"],
    ["clothe", "clothe"],
    ["beard", "beard"],
    ["aarons", "aa-rons"],
    ["skirts", "skirts"],
    ["laud", "laud"],
    ["lovely", "love-ly"],
    ["bringing", "bring-ing"],
    ["treasuries", "treas-ur-ies"],
    ["pharaoh", "pha-raoh"],
    ["sihon", "si-hon"],
    ["amorites", "am-or-ites"],
    ["og", "og"],
    ["levi", "levi"],
    ["lights", "lights"],
    ["rule", "rule"],
    ["stretched-out", "stret-ched_out"],
    ["two", "two"],
    ["overthrew", "o-ver-threw"],
    ["harps", "harps"],
    ["cunning", "cunn-ing"],
    ["roof", "roof"],
    ["prefer", "pre-fer"],
    ["served", "served"],
    ["throweth", "throw-eth"],
    ["magnified", "mag-ni-fied"],
    ["enduedst", "en-duedst"],
    ["searched", "searched"],
    ["down-sitting", "down_sitt-ing"],
    ["uprising", "up-ris-ing"],
    ["understandest", "un-der-stand-est"],
    ["acquainted", "ac-quain-ted"],
    ["beset", "be-set"],
    ["attain", "at-tain"],
    ["whither", "whi-ther"],
    ["fearfully", "fear-ful-ly"],
    ["wonderfully", "won-der-ful-ly"],
    ["imperfect", "im-per-fect"],
    ["members", "mem-bers"],
    ["sum", "sum"],
    ["wake", "wake"],
    ["unrighteously", "un-right-eous-ly"],
    ["sharpened", "sharp-ened"],
    ["adders", "ad-ders"],
    ["traps", "traps"],
    ["mischievous", "mis-chie-vous"],
    ["imagination", "i-ma-gi-na-tion"],
    ["hunt", "hunt"],
    ["lifting", "lift-ing"],
    ["refuse", "re-fuse"],
    ["balms", "balms"],
    ["heweth", "hew-eth"],
    ["nets", "nets"],
    ["complaints", "comp-laints"],
    ["knewest", "knew-est"],
    ["cared", "cared"],
    ["righteousness", "right-eous-ness"],
    ["gaspeth", "gasp-eth"],
    ["waxeth", "wax-eth"],
    ["faint", "faint"],
    ["fortress", "fort-ress"],
    ["deliverer", "de-li-ver-er"],
    ["regardest", "re-gard-est"],
    ["lightning", "light-ning"],
    ["talketh", "talk-eth"],
    ["ten-stringed", "ten_stringed"],
    ["grow", "grow"],
    ["plants", "plants"],
    ["polished", "pol-ished"],
    ["garners", "gar-ners"],
    ["store", "store"],
    ["fields", "fields"],
    ["decay", "de-cay"],
    ["leading", "lead-ing"],
    ["case", "case"],
    ["abundant", "ab-un-dant"],
    ["mightiness", "migh-ti-ness"],
    ["ages", "a-ges"],
    ["faithfully", "faith-ful-ly"],
    ["feedeth", "feed-eth"],
    ["looseth", "loos-eth"],
    ["blind", "blind"],
    ["upside", "up-side"],
    ["outcasts", "out-casts"],
    ["medicine", "me-di-cine"],
    ["infinite", "in-fin-ite"],
    ["prepareth", "pre-par-eth"],
    ["fodder", "fod-der"],
    ["ravens", "ra-vens"],
    ["legs", "legs"],
    ["flour", "flour"],
    ["wheat", "wheat"],
    ["swiftly", "swift-ly"],
    ["wool", "wool"],
    ["hoarfrost", "hoar-frost"],
    ["ice", "ice"],
    ["morsels", "mor-sels"],
    ["bloweth", "blow-eth"],
    ["flow", "flow"],
    ["ordinances", "or-di-nan-ces"],
    ["heights", "heights"],
    ["created", "cre-at-ed"],
    ["deeps", "deeps"],
    ["hail", "hail"],
    ["vapours", "va-pours"],
    ["fulfilling", "ful-fil-ling"],
    ["serveth", "serv-eth"],
    ["dance", "dance"],
    ["meek-hearted", "meek_heart-ed"],
    ["beds", "beds"],
    ["two-edged", "two_edged"],
    ["chains", "chains"],
    ["nobles", "no-bles"],
    ["links", "links"],
    ["dances", "dan-ces"],
    ["pipe", "pipe"],
    ["well-tuned", "well_tuned"],
    ["cymbals", "cym-bals"],
];
